var ils;
(function (ils) {
    class PreferredMoveInType {
        constructor(item) {
            if (!item) {
                item = {};
            }
            // Copy the contents of the passed in item using the native javascript `Object.assign(dest, source)`
            Object.assign(this, item);
        }
    }
    ils.PreferredMoveInType = PreferredMoveInType;
})(ils || (ils = {}));

var ils;
(function (ils) {
    let showcase;
    (function (showcase) {
        let FormType;
        (function (FormType) {
            FormType["GetMoreInfo"] = "Get More Info";
            FormType["CheckAvailability"] = "Check Availability";
            FormType["ScheduleTour"] = "Schedule a Tour";
            FormType["ApplyNow"] = "Apply Now";
        })(FormType = showcase.FormType || (showcase.FormType = {}));
        let ViewType;
        (function (ViewType) {
            ViewType["NameInfo"] = "Name Info";
            ViewType["ContactInfo"] = "Contact Info";
            ViewType["TourDate"] = "Tour Date";
            ViewType["FloorPlans"] = "Floor Plans";
            ViewType["RoommatesQuestion"] = "Roommates Question";
            ViewType["Roommates"] = "List of Roommates";
            ViewType["Comments"] = "Move-in Date and Comments";
        })(ViewType = showcase.ViewType || (showcase.ViewType = {}));
    })(showcase = ils.showcase || (ils.showcase = {}));
    class ProgressStep {
        constructor(stepName, parentForms, order, isComplete) {
            this.StepName = ko.observable(stepName);
            this.IsComplete = ko.observable(isComplete);
            this.ParentForms = parentForms;
            this.Order = ko.observable(order);
            this.ForceHide = ko.observable(false);
            this.ForceShow = ko.observable(false);
            this.IsVisible = (formType, showRoommates, hasRoommates) => {
                if (this.ForceShow()) {
                    return true;
                }
                if (this.ForceHide()) {
                    return false;
                }
                if (this.StepName() === showcase.ViewType.RoommatesQuestion) {
                    return showRoommates && this.ParentForms.some(pf => pf === formType);
                }
                if (this.StepName() === showcase.ViewType.Roommates) {
                    return showRoommates && hasRoommates && this.ParentForms.some(pf => pf === formType);
                }
                return this.ParentForms.some(pf => pf === formType);
            };
            this.StepTiming = new ils.PageTiming(stepName);
            this.ForceHide.subscribe((newVal) => {
                if (newVal === true) {
                    this.ForceShow(false);
                }
            }, this);
            this.ForceShow.subscribe((newVal) => {
                if (newVal === true) {
                    this.ForceHide(false);
                }
            }, this);
        }
    }
    ils.ProgressStep = ProgressStep;
    class LeadFormStepManager {
        constructor(item = {}) {
            var _a, _b, _c;
            ////////////////////////////////////////////////////////////////////////////////////////////////////////
            // This is basically our state machine to manage the state on each step. The way we navigate the form
            // depends on the type of form we're in (i.e. 'Get More Info, 'Schedule a Tour', 'Check Availability', or
            // 'Apply Now').
            // This means we have to set the 'Next' and 'Back' buttons based on the type of form we're in and the 
            // responses of the user to some of those answers (i.e. 'Do you have roommates?').
            ///////////////////////////////////////////////////////////////////////////////////////////////////////
            this.setFormState = (newVal) => {
                if (!newVal) {
                    return;
                }
                this.StartTrackingForNewStep(newVal);
                let activeIndex = this.ActiveViews().findIndex((val, idx, steps) => { return val.StepName() === newVal; });
                this.BackStepVisible(activeIndex > 0);
                switch (newVal) {
                    case showcase.ViewType.NameInfo:
                        this.MainText(`${this.CommunityName()}`);
                        if (this.FormType() == showcase.FormType.GetMoreInfo) {
                            this.Pretext("Let's introduce you to");
                        }
                        else if (this.FormType() == showcase.FormType.CheckAvailability) {
                            this.Pretext("Let's check availability at");
                        }
                        else if (this.FormType() == showcase.FormType.ScheduleTour) {
                            this.Pretext("Let's schedule your tour at");
                        }
                        else if (this.FormType() === showcase.FormType.ApplyNow) {
                            this.Pretext("Get started on your application for");
                        }
                        break;
                    case showcase.ViewType.TourDate:
                        this.Pretext("Tour Request");
                        this.MainText("What date and time works best for you?");
                        break;
                    case showcase.ViewType.RoommatesQuestion:
                        this.Pretext(`${this.CommunityName()} is a "by the room" student community`);
                        this.MainText("Have you thought about roommates?");
                        break;
                    case showcase.ViewType.Roommates:
                        this.Pretext(`${this.CommunityName()} is a "by the room" student community`);
                        this.MainText("Who are your roommates?");
                        break;
                    case showcase.ViewType.FloorPlans:
                        this.Pretext(this.ActiveView());
                        this.MainText("Which floor plan(s) interest you?");
                        break;
                    case showcase.ViewType.Comments:
                        this.Pretext(this.ActiveView());
                        this.MainText("Anything we can pass along to the team?");
                        break;
                    default:
                        break;
                }
            };
            this.ActiveView = !item.ActiveView ? ko.observable(showcase.ViewType.NameInfo) : ko.observable(item.ActiveView);
            this.FormType = !item.FormType ? ko.observable(showcase.FormType.GetMoreInfo) : ko.observable(item.FormType);
            this.BackStepVisible = ko.observable(false);
            this.JustMe = !item.JustMe ? ko.observable(false) : ko.observable(item.JustMe);
            this.HasRoommates = !item.HasRoommates ? ko.observable(false) : ko.observable(item.HasRoommates);
            this.NeedRoommate = !item.NeedRoommate ? ko.observable(false) : ko.observable(item.NeedRoommate);
            this.ShowRoommates = !item.ShowRoommatesOption ? ko.observable(false) : ko.observable(item.ShowRoommatesOption);
            this.Pretext = ko.observable("Let's introduce you to");
            this.MainText = ko.observable(`${((_a = item.CommunityName) !== null && _a !== void 0 ? _a : "")}`);
            this.CommunityName = ko.observable((_b = item.CommunityName) !== null && _b !== void 0 ? _b : "");
            this.CommunityId = ko.observable((_c = item.CommunityId) !== null && _c !== void 0 ? _c : 0);
            this.ProgressSteps = ko.observableArray([]);
            this.HasRoommateQuestionError = ko.observable(false);
            this.TourDateValidationMessage = ko.observable("");
            this.HasStartedForm = ko.observable(false);
            let isActiveSorting = false;
            ////////////////////////////////////////////////////////////////////////////////////////////////////////
            // This is setting up all the possible steps we can take in the form. This is part of how we manage
            // state as well as what actions to take on a step. The Order() value of each step is two more than 
            // the previous one so that we have the ability to easily change the order of the steps inside an A/B
            // test using Google Optimize via running some Javascript when the A/B test loads.
            ////////////////////////////////////////////////////////////////////////////////////////////////////////
            const progressSteps = [];
            for (let val in showcase.ViewType) {
                let parentForms = [];
                let value = showcase.ViewType[val];
                if (value == showcase.ViewType.NameInfo) {
                    parentForms.push(showcase.FormType.GetMoreInfo);
                    parentForms.push(showcase.FormType.ScheduleTour);
                    parentForms.push(showcase.FormType.CheckAvailability);
                    parentForms.push(showcase.FormType.ApplyNow);
                    progressSteps.push(new ProgressStep(value, parentForms, 1, true));
                    continue;
                }
                if (value == showcase.ViewType.TourDate) {
                    parentForms.push(showcase.FormType.ScheduleTour);
                    progressSteps.push(new ProgressStep(value, parentForms, 3, false));
                    continue;
                }
                if (value == showcase.ViewType.ContactInfo) {
                    // Contact Info (email/phone) has been merged into the NameInfo step
                    continue;
                }
                // Combining the Roommates steps to not overwhelm the user with the progress bar
                if (value === showcase.ViewType.RoommatesQuestion || value === showcase.ViewType.Roommates) {
                    if (this.ShowRoommates()) {
                        parentForms.push(showcase.FormType.GetMoreInfo);
                        parentForms.push(showcase.FormType.ScheduleTour);
                        parentForms.push(showcase.FormType.CheckAvailability);
                        let step = new ProgressStep(value, parentForms, value === showcase.ViewType.RoommatesQuestion ? 7 : 8, false);
                        step.ForceHide(value === showcase.ViewType.Roommates);
                        progressSteps.push(step);
                    }
                    continue;
                }
                if (value == showcase.ViewType.FloorPlans) {
                    parentForms.push(showcase.FormType.ScheduleTour);
                    parentForms.push(showcase.FormType.CheckAvailability);
                    progressSteps.push(new ProgressStep(value, parentForms, 10, false));
                    continue;
                }
                if (value == showcase.ViewType.Comments) {
                    parentForms.push(showcase.FormType.GetMoreInfo);
                    parentForms.push(showcase.FormType.ScheduleTour);
                    parentForms.push(showcase.FormType.CheckAvailability);
                    progressSteps.push(new ProgressStep(value, parentForms, 12, false));
                    continue;
                }
            }
            this.ProgressSteps.push(...progressSteps.sort((l, r) => { return l.Order() < r.Order() ? -1 : 1; }));
            // Subscribe to the Order() property of each step so that if it's changed we re-sort the overall ProgressSteps array
            this.ProgressSteps().forEach((val, idx, steps) => {
                val.Order.subscribe((newVal) => {
                    if (isActiveSorting) {
                        return;
                    }
                    isActiveSorting = true;
                    this.ProgressSteps.sort((l, r) => {
                        return l.Order() < r.Order() ? -1 : 1;
                    });
                    this.ProgressSteps().forEach((val, idx, steps) => {
                        if (idx === 0) {
                            val.Order(idx + 1);
                            return;
                        }
                        val.Order(steps[idx - 1].Order() + 2);
                    });
                    isActiveSorting = false;
                });
            });
            this.ShowApplicationLinkButton = ko.pureComputed(() => {
                return this.FormType() === showcase.FormType.ApplyNow;
            });
            this.ActiveViews = ko.pureComputed(() => {
                return this.ProgressSteps().filter((val, idx, steps) => {
                    return val.IsVisible(this.FormType(), this.ShowRoommates(), this.HasRoommates());
                }).sort((l, r) => { return l.Order() < r.Order() ? -1 : 1; });
            }, this);
            // Must be defined after ActiveViews: evaluator calls this.ActiveViews().
            this.SubmitButtonText = ko.pureComputed(() => {
                const activeIndex = this.ActiveViews().findIndex(v => v.StepName() === this.ActiveView());
                const isLastStep = activeIndex === this.ActiveViews().length - 1;
                const partialCaptureOn = typeof ils !== "undefined" && ils.enableCdpPartialCaptureHangfire != null && ko.unwrap(ils.enableCdpPartialCaptureHangfire);
                // CDP partial-capture step-1 label for every guest-card flow except Apply Now (which uses "Continue to Application" on its single step).
                if (this.ActiveView() === showcase.ViewType.NameInfo && partialCaptureOn && this.FormType() !== showcase.FormType.ApplyNow) {
                    return "Submit and Continue";
                }
                if (!isLastStep) {
                    return "Next";
                }
                return this.FormType() === showcase.FormType.ApplyNow ? "Continue to Application" : "Submit";
            }, this);
            this.ProgressSteps.subscribe((arrayChangeVal) => {
                this.ActiveView(this.ActiveViews()[0].StepName());
                this.ProgressSteps().forEach((val, idx, steps) => {
                    val.IsComplete(val.StepName() === this.ActiveViews()[0].StepName());
                }, this);
            }, this, "arrayChange");
            this.ActiveStep = ko.pureComputed(() => {
                return this.ProgressSteps().find((val, idx, steps) => {
                    return val.StepName() == this.ActiveView();
                });
            }, this);
            this.NextStep = ko.pureComputed(() => {
                for (let i = 0; i < this.ActiveViews().length; i++) {
                    let val = this.ActiveViews()[i];
                    if (!val || !val.IsVisible(this.FormType(), this.ShowRoommates(), this.HasRoommates())) {
                        continue;
                    }
                    if (val.Order() > this.ActiveStep().Order()) {
                        return val.StepName();
                    }
                }
                return this.ActiveView();
            }, this);
            this.BackStep = ko.pureComputed(() => {
                for (let i = this.ActiveViews().length - 1; i >= 0; i--) {
                    let val = this.ActiveViews()[i];
                    if (!val || !val.IsVisible(this.FormType(), this.ShowRoommates(), this.HasRoommates())) {
                        continue;
                    }
                    if (val.Order() < this.ActiveStep().Order()) {
                        return val.StepName();
                    }
                }
                return this.ActiveView();
            }, this);
            this.IconHtml = ko.pureComputed(() => {
                let html = [];
                switch (this.FormType()) {
                    case showcase.FormType.GetMoreInfo:
                        const getMoreInfoIcons = [
                            `<span class="ilsicon ilsicon-faq-bubble"></span>`
                        ];
                        html.push(...getMoreInfoIcons);
                        break;
                    case showcase.FormType.ScheduleTour:
                        const scheduleTourIcons = [
                            `<span class="ilsicon-stack">`,
                            `   <span class="ilsicon ilsicon-calendar-p3 third"></span><span class="ilsicon ilsicon-calendar brand-primary"></span><span class="ilsicon ilsicon-calendar-p2 brand-secondary"></span>`,
                            `</span>`
                        ];
                        html.push(...scheduleTourIcons);
                        break;
                    case showcase.FormType.CheckAvailability:
                        const checkAvailabilityIcons = [
                            `<span class="ilsicon-stack">`,
                            `   <span class="ilsicon ilsicon-magnify-p3 third"></span><span class="ilsicon ilsicon-magnify-p1 brand-primary"></span><span class="ilsicon ilsicon-magnify-p2 brand-secondary"></span>`,
                            `</span>`
                        ];
                        html.push(...checkAvailabilityIcons);
                        break;
                    case showcase.FormType.ApplyNow:
                        const applyNowIcons = [
                            `<span class="ilsicon ilsicon-renters"></span>`
                        ];
                        html.push(...applyNowIcons);
                        break;
                    default:
                        const defaultIcons = [
                            `<span class="ilsicon ilsicon-faq-bubble"></span>`
                        ];
                        html.push(...defaultIcons);
                        break;
                }
                return html.join('');
            }, this);
            let isFormTypeSwitching = false;
            this.ActiveView.subscribe((newVal) => {
                if (!isFormTypeSwitching) {
                    const activeIndex = this.ActiveViews().findIndex(v => v.StepName() === newVal);
                    ils.trackStepFormNavigation(this.FormType(), newVal, activeIndex + 1, this.ActiveViews().length, this.CommunityName(), this.CommunityId());
                }
                this.setFormState(newVal);
            });
            this.FormType.subscribe((newVal) => {
                isFormTypeSwitching = true;
                // Compute active views inline for the new form type to guarantee fresh data
                const newActiveViews = this.ProgressSteps().filter(step => step.IsVisible(newVal, this.ShowRoommates(), this.HasRoommates())).sort((l, r) => l.Order() < r.Order() ? -1 : 1);
                if (newActiveViews.length > 0) {
                    const firstStep = newActiveViews[0].StepName();
                    ils.trackStepFormNavigation(newVal, firstStep, 1, newActiveViews.length, this.CommunityName(), this.CommunityId());
                    if (this.ActiveView() == firstStep) {
                        this.setFormState(firstStep);
                    }
                    else {
                        this.ActiveView(firstStep);
                    }
                }
                isFormTypeSwitching = false;
                const activeStepIndex = this.ProgressSteps().findIndex((val, idx, allSteps) => {
                    return val.StepName() == this.ActiveView();
                });
                this.ProgressSteps().forEach((val, idx, allSteps) => {
                    if (activeStepIndex < 0) {
                        val.IsComplete(false);
                        return;
                    }
                    if (val.Order() > allSteps[activeStepIndex].Order()) {
                        val.IsComplete(false);
                    }
                    else {
                        val.IsComplete(true);
                    }
                });
            });
            this.NavigateToNextStep = () => {
                this.ProgressSteps().forEach((val, idx, steps) => {
                    if (val.StepName() === this.NextStep()) {
                        val.IsComplete(true);
                    }
                }, this);
                const btn = this.SubmitButtonText();
                const activeIndex = this.ActiveViews().findIndex((val) => val.StepName() === this.ActiveView());
                const isLastStep = activeIndex >= 0 && activeIndex === this.ActiveViews().length - 1;
                if (btn === "Submit" || btn === "Continue to Application" ||
                    (btn === "Submit and Continue" && isLastStep && this.FormType() === showcase.FormType.ApplyNow)) {
                    // Track the final step before submitting since ActiveView won't change and setFormState won't be called
                    ils.trackStepFormNavigation(this.FormType(), this.ActiveView(), activeIndex + 1, this.ActiveViews().length, this.CommunityName(), this.CommunityId());
                    ils.viewModel.ReadyToSubmit(true);
                    return;
                }
                this.ActiveView(this.NextStep());
            };
            this.NavigateBackOneStep = () => {
                this.ProgressSteps().forEach((val, dx, steps) => {
                    if (val.StepName() === this.ActiveView()) {
                        val.IsComplete(false);
                    }
                });
                this.ActiveView(this.BackStep());
            };
            this.FormClass = ko.pureComputed(() => {
                switch (this.ActiveView()) {
                    case showcase.ViewType.NameInfo:
                        return "c-guest-card-element__form c-guest-card-element__form--name";
                    case showcase.ViewType.TourDate:
                        return "c-guest-card-element__form c-guest-card-element__form--tour";
                    case showcase.ViewType.Comments:
                        return "c-guest-card-element__form c-guest-card-element__form--comments";
                    case showcase.ViewType.Roommates:
                    case showcase.ViewType.RoommatesQuestion:
                        return "c-guest-card-element__form c-guest-card-element__form--roommates";
                    default:
                        return "c-guest-card-element__form";
                }
            });
            this.NavigateTo = (progressStep) => {
                for (let val in showcase.ViewType) {
                    let value = showcase.ViewType[val];
                    if (value == progressStep.StepName()) {
                        this.ActiveView(value);
                        return;
                    }
                }
            };
            this.TurnOnStepTimeTracking = (isFormActive) => {
                const activeIndex = this.ProgressSteps().findIndex((val, idx, steps) => {
                    return val.StepName() === this.ActiveView();
                });
                if (activeIndex < 0) {
                    this.ProgressSteps().forEach((val, idx, steps) => {
                        val.StepTiming.stopTracking();
                    });
                    return;
                }
                let activeStep = this.ProgressSteps()[activeIndex];
                if (!isFormActive) {
                    activeStep.StepTiming.stopTracking();
                }
                else {
                    activeStep.StepTiming.startTracking();
                }
            };
            this.StartTrackingForNewStep = (stepName) => {
                this.ProgressSteps().forEach((val, idx, steps) => {
                    if (val.StepTiming.isCurrentlyTracking()) {
                        val.StepTiming.stopTracking();
                        if (!ils.isSiteLive) {
                            console.log(`Current total time tracked for ${val.StepTiming.name} so far is ${val.StepTiming.timeDuration}.`);
                        }
                    }
                });
                const activeIndex = this.ProgressSteps().findIndex((val, idx, steps) => {
                    return val.StepName() === stepName;
                });
                if (activeIndex < 0) {
                    return;
                }
                let activeStep = this.ProgressSteps()[activeIndex];
                activeStep.StepTiming.startTracking();
            };
            this.SendFormCompletionMetrics = (submitHasBeenClicked) => {
                gaSendStepFormCompletion(submitHasBeenClicked, this.HasStartedForm(), this.FormType(), this.ActiveView());
            };
            this.ContactStepErrors = null;
        }
    }
    ils.LeadFormStepManager = LeadFormStepManager;
})(ils || (ils = {}));

var ils;
(function (ils) {
    function getScheduleTourDateTimeValues() {
        const date = `${$("#uxNewDateOfVisit_uxDate").val() || ""}`.trim();
        const time = `${$("#uxNewTimeOfVisit").val() || ""}`.trim();
        return { date, time };
    }
    ils.getScheduleTourDateTimeValues = getScheduleTourDateTimeValues;
    function clearTourDateValidationMessage(stepManager) {
        stepManager.TourDateValidationMessage("");
    }
    ils.clearTourDateValidationMessage = clearTourDateValidationMessage;
    function validateOptionalTourDateTime(date, time) {
        const hasDate = date.length > 0;
        const hasTime = time.length > 0;
        if (!hasDate && !hasTime) {
            return { isValid: true, message: "", hasDateOrTime: false };
        }
        if (hasDate && !hasTime) {
            return { isValid: false, message: "Please select a time of visit.", hasDateOrTime: true };
        }
        if (!hasDate && hasTime) {
            return { isValid: false, message: "Please select a date of visit.", hasDateOrTime: true };
        }
        const parsed = parseTourDateTime(date, time);
        if (!parsed) {
            return { isValid: false, message: "Please enter a valid date and time.", hasDateOrTime: true };
        }
        if (parsed.getTime() <= Date.now()) {
            return { isValid: false, message: "Tour date and time must be in the future.", hasDateOrTime: true };
        }
        return { isValid: true, message: "", hasDateOrTime: true };
    }
    ils.validateOptionalTourDateTime = validateOptionalTourDateTime;
    function parseTourDateTime(dateStr, timeStr) {
        const dateParts = dateStr.split("/");
        if (dateParts.length !== 3) {
            return null;
        }
        const month = parseInt(dateParts[0], 10);
        const day = parseInt(dateParts[1], 10);
        const year = parseInt(dateParts[2], 10);
        if (isNaN(month) || isNaN(day) || isNaN(year)) {
            return null;
        }
        const timeMatch = timeStr.trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
        if (!timeMatch) {
            return null;
        }
        let hours = parseInt(timeMatch[1], 10);
        const minutes = parseInt(timeMatch[2], 10);
        const ampm = timeMatch[3].toUpperCase();
        if (ampm === "PM" && hours !== 12) {
            hours += 12;
        }
        if (ampm === "AM" && hours === 12) {
            hours = 0;
        }
        const result = new Date(year, month - 1, day, hours, minutes, 0, 0);
        if (result.getFullYear() !== year || result.getMonth() !== month - 1 || result.getDate() !== day) {
            return null;
        }
        return result;
    }
})(ils || (ils = {}));

var ils;
(function (ils) {
    class ProspectFormData {
        constructor(item = {}) {
            this.PrimaryGuest = !item.PrimaryGuest ? new ils.GuestCardInfo() : item.PrimaryGuest;
            this.Roommates = !item.Roommates ? ko.observableArray([]) : ko.observableArray(item.Roommates);
            this.ContactTypeID = !item.ContactTypeID ? ko.observable(1) : ko.observable(item.ContactTypeID);
            this.MoveInMonth = !item.MoveInMonth ? ko.observable() : ko.observable(item.MoveInMonth);
            this.MoveInDay = !item.MoveInDay ? ko.observable() : ko.observable(item.MoveInDay);
            this.SelectedFloorPlans = !item.SelectedFloorPlans ? ko.observableArray([]) : ko.observableArray(item.SelectedFloorPlans);
            this.SubmitHasBeenClicked = ko.observable(false);
            this.RemovedRoommates = ko.observableArray([]);
            this.DateOfVisit = ko.observable(null);
            this.StepManager = new ils.LeadFormStepManager({
                CommunityName: item.CommunityName,
                CommunityId: item.CommunityId,
                JustMe: item.JustMe,
                HasRoommates: item.HasRoommates,
                NeedRoommate: item.NeedRoommate,
                ShowRoommatesOption: item.ShowRoommatesOption,
                FormType: !item.ContactTypeID
                    ? ils.showcase.FormType.GetMoreInfo
                    : item.ContactTypeID == 1
                        ? ils.showcase.FormType.GetMoreInfo
                        : item.ContactTypeID == 2
                            ? ils.showcase.FormType.ScheduleTour
                            : item.ContactTypeID == 3
                                ? ils.showcase.FormType.CheckAvailability
                                : item.ContactTypeID == 5
                                    ? ils.showcase.FormType.ApplyNow
                                    : ils.showcase.FormType.GetMoreInfo
            });
            this.PrimaryGuestErrors = ko.validation.group(this.PrimaryGuest);
            this.RoommatesErrors = ko.validation.group(this.Roommates, {
                deep: true,
                live: true
            });
            this.HasErrors = ko.computed(() => {
                return this.PrimaryGuestErrors().length > 0 && this.SubmitHasBeenClicked();
            });
            this.IsFormValid = () => {
                this.PrimaryGuestErrors.showAllMessages();
                let hasErrors = this.HasErrors();
                if (this.StepManager.HasRoommates()) {
                    this.RoommatesErrors.showAllMessages();
                    hasErrors = hasErrors || (this.RoommatesErrors().length > 0 && this.SubmitHasBeenClicked());
                }
                return !hasErrors;
            };
            this.StepManager.HasRoommates.subscribe((newVal) => {
                if (!newVal) {
                    return;
                }
                if (newVal === true) {
                    this.StepManager.HasRoommateQuestionError(false);
                    this.StepManager.JustMe(false);
                }
                if (this.Roommates().length < 1) {
                    this.AddRoommate();
                }
            });
            this.StepManager.NeedRoommate.subscribe((newVal) => {
                if (newVal === true) {
                    this.StepManager.HasRoommateQuestionError(false);
                    this.StepManager.JustMe(false);
                }
            });
            this.StepManager.JustMe.subscribe((newVal) => {
                if (newVal === true) {
                    this.StepManager.HasRoommateQuestionError(false);
                    this.StepManager.HasRoommates(false);
                    this.StepManager.NeedRoommate(false);
                }
            });
            this.AddRoommate = () => {
                var nextOrder = this.Roommates().length + 1;
                if (this.RemovedRoommates().length > 0) {
                    var removedRoommate = this.RemovedRoommates.pop();
                    removedRoommate.RoommateOrder(nextOrder);
                    this.Roommates.push(removedRoommate);
                    return;
                }
                const newRoommate = new ils.Roommate({
                    GuestInfo: new ils.GuestCardInfo({ RequireEmailOrPhone: false }),
                    RoommateOrder: nextOrder
                });
                this.Roommates.push(newRoommate);
            };
            this.RemoveRoommate = (RoommateLocalId) => {
                const removedItems = this.Roommates.remove((rm) => {
                    return rm.RoommateLocalId() == RoommateLocalId;
                });
                const removed = removedItems[0];
                this.RemovedRoommates.push(removed);
                if (this.Roommates().length < 1) {
                    this.StepManager.HasRoommates(false);
                    return;
                }
                for (var i = 0; i < this.Roommates().length; i++) {
                    this.Roommates()[i].RoommateOrder(i + 1);
                }
            };
            this.ContactTypeID.subscribe((newVal) => {
                const formType = !newVal
                    ? ils.showcase.FormType.GetMoreInfo
                    : newVal == 1
                        ? ils.showcase.FormType.GetMoreInfo
                        : newVal == 2
                            ? ils.showcase.FormType.ScheduleTour
                            : newVal == 3
                                ? ils.showcase.FormType.CheckAvailability
                                : newVal === 5
                                    ? ils.showcase.FormType.ApplyNow
                                    : ils.showcase.FormType.GetMoreInfo;
                this.StepManager.FormType(formType);
            });
            this.StepManager.ContactStepErrors = ko.validation.group([this.PrimaryGuest.Email, this.PrimaryGuest.Phone]);
            this.OnNext = () => {
                let isStepValid = false;
                switch (this.StepManager.ActiveView()) {
                    case ils.showcase.ViewType.NameInfo:
                        this.StepManager.HasStartedForm(true);
                        this.PrimaryGuest.EnableGuestValidation(true);
                        let guestNameErrors = ko.validation.group(this.PrimaryGuest.GuestName);
                        const guestNameValid = ko.validation.validateObservable(this.PrimaryGuest.GuestName);
                        guestNameErrors.showAllMessages();
                        this.StepManager.ContactStepErrors.showAllMessages();
                        const contactValid = this.StepManager.ContactStepErrors().length < 1;
                        isStepValid = guestNameValid && contactValid;
                        this.PrimaryGuest.EnableGuestValidation(!isStepValid);
                        break;
                    case ils.showcase.ViewType.TourDate:
                        {
                            const { date, time } = ils.getScheduleTourDateTimeValues();
                            const tourDateValidation = ils.validateOptionalTourDateTime(date, time);
                            this.StepManager.TourDateValidationMessage(tourDateValidation.isValid ? "" : tourDateValidation.message);
                            isStepValid = tourDateValidation.isValid;
                        }
                        break;
                    case ils.showcase.ViewType.RoommatesQuestion:
                        this.StepManager.HasRoommateQuestionError(false);
                        isStepValid = true;
                        if (this.StepManager.HasRoommates()) {
                            this.StepManager.ProgressSteps().forEach((val, idx, steps) => {
                                if (val.StepName() === ils.showcase.ViewType.Roommates) {
                                    val.ForceShow(true);
                                }
                            });
                            this.Roommates().forEach((val, idx, allRoommates) => {
                                val.GuestInfo.EnableGuestValidation(false);
                            });
                        }
                        else {
                            this.StepManager.ProgressSteps().forEach((val, idx, steps) => {
                                if (val.StepName() === ils.showcase.ViewType.Roommates) {
                                    val.ForceHide(true);
                                }
                            });
                        }
                        break;
                    case ils.showcase.ViewType.Roommates:
                        let indexesToRemove = [];
                        for (let i = this.Roommates().length - 1; i > -1; i--) {
                            let val = this.Roommates()[i];
                            // We don't validate against completely blank roommates so we will remove them from the list of roommates
                            if (!val.GuestInfo.GuestName() && !val.GuestInfo.Email() && !val.GuestInfo.Phone()) {
                                indexesToRemove.push(i);
                                this.Roommates.remove(val);
                                continue;
                            }
                            // otherwise we go ahead and enable the validation on the roommate entered
                            val.GuestInfo.EnableGuestValidation(true);
                        }
                        if (this.Roommates().length < 1) {
                            this.StepManager.HasRoommates(false);
                            this.StepManager.JustMe(true);
                            isStepValid = true;
                            this.StepManager.ProgressSteps().forEach((val, idx, steps) => {
                                if (val.StepName() === ils.showcase.ViewType.Roommates) {
                                    val.ForceHide(true);
                                }
                            });
                            break;
                        }
                        this.RoommatesErrors.showAllMessages();
                        isStepValid = this.RoommatesErrors().length < 1;
                        break;
                    default:
                        isStepValid = true;
                        break;
                }
                if (isStepValid) {
                    const wasNameInfoStep = this.StepManager.ActiveView() === ils.showcase.ViewType.NameInfo;
                    this.StepManager.NavigateToNextStep();
                    if (wasNameInfoStep) {
                        const form = this;
                        window.setTimeout(() => ils.schedulePartialCaptureAfterNameStep(form), 0);
                    }
                }
            };
            this.OnBack = () => {
                switch (this.StepManager.ActiveView()) {
                    case ils.showcase.ViewType.Roommates:
                        this.Roommates().forEach((val, idx, allRoommates) => {
                            val.GuestInfo.EnableGuestValidation(false);
                        });
                        break;
                    default:
                        break;
                }
                this.StepManager.NavigateBackOneStep();
            };
            this.NavigateStepTo = (progressStep) => {
                if (!progressStep.IsComplete()) {
                    return;
                }
                this.StepManager.NavigateTo(progressStep);
                const activeStepIndex = this.StepManager.ProgressSteps().findIndex((val, idx, allSteps) => {
                    return val.StepName() == this.StepManager.ActiveView();
                });
                this.StepManager.ProgressSteps().forEach((val, idx, allSteps) => {
                    if (activeStepIndex < 0) {
                        val.IsComplete(false);
                        return;
                    }
                    if (val.Order() > allSteps[activeStepIndex].Order()) {
                        val.IsComplete(false);
                    }
                });
            };
        }
    }
    ils.ProspectFormData = ProspectFormData;
})(ils || (ils = {}));

var ils;
(function (ils) {
    class FloorPlanInfo {
        constructor(item) {
            if (!item) {
                item = {};
            }
            // Copy the contents of the passed in item using the native javascript `Object.assign(dest, source)`
            Object.assign(this, item);
            // Set the remaining values based on more detailed logic
            this.ImageUrl = this.Image && this.Image != '' ? (this.Image && this.Image.toLowerCase().indexOf('http') == -1 ? imageDomain + "uploads/floorplans/" : "") + this.Image : 'missing.jpg';
            this.ImageSrc = (this.ImageUrl && this.ImageUrl.toLowerCase().indexOf('http') == -1 ? (this.ImageUrl + "?preset=floorplan&404=floorplan") : imageDomain + "external-resizer.aspx?width=220&height=245&scale=both&404=floorplan&filename=" + this.ImageUrl);
            this.NumberBedroomsText = this.NumberBedrooms > 0 ? this.NumberBedrooms + "-bedroom" : "Studio";
            this.NumberBedroomsLongText = this.NumberBedrooms > 0 ? this.NumberBedrooms + " Bedroom" + (this.NumberBedrooms > 1 ? "s" : "") : "Studio";
            this.ActiveConcessionAmount = Number(this.ActiveConcessionAmount) || 0;
            this.DisplayRate = this.getDisplayRateValue();
            this.Pricing = this.Price == 0
                ? (this.IsRequiredMonthlyFeesEnabled ? "Call for details" : "Please call for details")
                : ils.AddCommas(this.DisplayRate) + (this.IsRequiredMonthlyFeesEnabled ? ' / ' : ' per ') + (this.PriceByUnit ? 'Month' : 'Room');
            this.PriceChangeExtra = this.PriceChange == 0 ? "" : "The price of this floor plan has gone " + (this.PriceChange > 0 ? "up " : "down ") + Math.abs(this.PriceChange * 100).toFixed(0) + "% in the last week. Call today and ask how you can lock in the current rate.";
            this.Specials = item.Specials;
            this.Details = ko.computed(() => {
                if (this.Specials) {
                    var specialsSplit = this.Specials.split('\n');
                    if (specialsSplit.length > 1 && specialsSplit[0].length < 1 && specialsSplit[1].length > 0) {
                        return specialsSplit[1].split('\n');
                    }
                    return this.Specials.split('\n');
                }
                return [];
            });
            this.HasDetails = ko.computed(() => {
                return this.Details().length > 0;
            });
            this.HasMorePhotos = ko.computed(() => {
                return $(`.media-items [data-additional-galleries*=${this.FloorPlanID}]`).length > 0;
            });
            this.HasMoreVirtualTours = ko.computed(() => {
                return $(`.media-items [data-floorplan-virtual-tour*=${this.FloorPlanID}]`).length > 0;
            });
            this.HasMorePhotoText = ko.computed(() => {
                return !this.HasMorePhotos() && !this.HasMoreVirtualTours()
                    ? ""
                    : this.HasMoreVirtualTours()
                        ? `<span class="glyphicon glyphicon-play-circle"></span><span class="label-text">&nbsp;3Dx Virtual Tour</span>`
                        //? `<span class="ilsicon ilsicon-results">&nbsp;3Dx Virtual Tour</span>`
                        : `<span class="ilsicon ilsicon-results"></span>&nbsp;More Photos`;
            });
            this.InitialFloorPlanCarouselImage = ko.computed(() => {
                return this.ImageUrl;
                // The code below works but the VirtualTourUrl is used as an image when the overlay is launched which
                // won't work since it's a URL to an iFrame.
                //return this.HasMoreVirtualTours() && this.VirtualTourUrl
                //    ? this.VirtualTourUrl
                //    : this.ImageUrl;
            });
        }
        /** Exact rate (price + concession + fees). Listing display uses Math.ceil of this (DEV-2219). */
        getExactDisplayRateValue() {
            if (!this.Price || this.Price == 0)
                return 0;
            const concession = Number(this.ActiveConcessionAmount) || 0;
            let fees = 0;
            if (this.IsRequiredMonthlyFeesEnabled) {
                const feeAmt = typeof ils.requiredMonthlyFees !== 'undefined'
                    ? parseFloat(ils.requiredMonthlyFees)
                    : 0;
                if (!isNaN(feeAmt) && feeAmt > 0)
                    fees = feeAmt;
            }
            return this.Price + concession + fees;
        }
        /** Matches server FloorPlan.GetListingDisplayRateValue: round UP to nearest whole dollar. */
        getDisplayRateValue() {
            return Math.ceil(this.getExactDisplayRateValue());
        }
    }
    ils.FloorPlanInfo = FloorPlanInfo;
})(ils || (ils = {}));

var ils;
(function (ils) {
    var iLSHelpers = Helpers;
    class GuestCardInfo {
        constructor(item) {
            if (!item) {
                item = {};
            }
            this.FirstName = (typeof (item.FirstName) == "undefined" ? ko.observable(null) : ko.observable(item.FirstName));
            this.LastName = (typeof (item.LastName) == "undefined" ? ko.observable(null) : ko.observable(item.LastName));
            this.Email = (typeof (item.Email) == "undefined" ? ko.observable(null) : ko.observable(item.Email));
            this.Phone = (typeof (item.Phone) == "undefined" ? ko.observable(null) : ko.observable(item.Phone));
            this.MoveInDate = typeof (item.MoveInDate) == "undefined" ? ko.observable(null) : ko.observable(item.MoveInDate);
            this.RenterCommentsAndQuestions = typeof (item.RenterCommentsAndQuestions) == "undefined" ? ko.observable(null) : ko.observable(item.RenterCommentsAndQuestions);
            this.GuestName = !this.FirstName() && !this.LastName() ? ko.observable(null) : ko.observable(`${this.FirstName()} ${this.LastName()}`);
            this.EnableGuestValidation = ko.observable(false);
            this.RequireEmailOrPhone = typeof (item.RequireEmailOrPhone) == "undefined" ? ko.observable(true) : ko.observable(item.RequireEmailOrPhone);
            this.cdpSessionId = ils.cdpSessionId;
            this.MissingEmailAndPhone = () => {
                const emailAddress = this.Email();
                const phoneNumber = this.Phone();
                const isMissingPhoneAndEmail = !ko.validation.rules.required.validator(emailAddress, true) && !ko.validation.rules.required.validator(phoneNumber, true);
                return isMissingPhoneAndEmail;
            };
            // Setup Validation
            this.FirstName.extend({
                required: {
                    message: "First Name is Required"
                },
                maxLength: 50
            });
            this.LastName.extend({
                required: {
                    message: "Last Name is Required"
                },
                maxLength: 50
            });
            this.Email.extend({
                required: {
                    message: "Please enter a valid email address and/or a valid phone number",
                    onlyIf: () => {
                        return this.MissingEmailAndPhone() && this.RequireEmailOrPhone();
                    }
                },
                email: {
                    onlyIf: () => {
                        const e = this.Email();
                        return this.EnableGuestValidation() && e != null && e.trim().length > 0;
                    }
                },
                maxLength: 382
            });
            this.Phone.extend({
                phoneiLS: {
                    onlyIf: () => {
                        return this.EnableGuestValidation() && this.Phone() !== null && this.Phone().trim().length > 0;
                    }
                }
            });
            this.RenterCommentsAndQuestions.extend({
                maxLength: 500
            });
            this.GuestName.extend({
                required: {
                    message: "Please enter a full name.",
                    onlyIf: () => {
                        return !ils.viewModel
                            ? false
                            : true;
                    }
                },
                fullNameiLS: {
                    onlyIf: () => {
                        return this.EnableGuestValidation();
                    }
                }
                //validation: {
                //    validator: (val: string) => {
                //        if (!val) {
                //            return false;
                //        }
                //        let valSplit = val.trim().split(' ');
                //        return valSplit.length > 1;
                //    },
                //    message: "Please enter a first and last name.",
                //    onlyIf: () => {
                //        return this.EnableGuestValidation();
                //    }
                //}
            });
            // Subscribe to the GuestName observable so we can split it out into first and last name
            this.GuestName.subscribe((newValue) => {
                if (!this.GuestName() || this.GuestName().length < 1) {
                    return;
                }
                const nameSplit = this.GuestName().trim().split(' ');
                const namesLength = nameSplit.length;
                if (namesLength < 1) {
                    return;
                }
                const first = namesLength > 1 ?
                    nameSplit.map((val, index, array) => {
                        if (index <= namesLength - 2)
                            return val.trim().toTitleCase();
                    }).join(' ')
                    : nameSplit[0].length > 0
                        ? nameSplit[0].trim().toTitleCase()
                        : "";
                const last = namesLength > 1 ? nameSplit[namesLength - 1].trim().toTitleCase() : "";
                this.FirstName(first.trim());
                this.LastName(last.trim());
            });
            ////////////////////////////
            // General Purpose functions
            ///////////////////////////
            this.formatPhone = (data, event) => {
                const val = $(event.currentTarget).val();
                if (!val || event.keyCode == 8) {
                    return;
                }
                const formattedPhone = iLSHelpers.formatPhone(val, { allowExtensions: false, includeParenthesis: true, allowInternational: false });
                $(event.currentTarget).val(formattedPhone);
                this.Phone(formattedPhone);
            };
            this.formatGuestName = (data, event) => {
                const val = $(event.currentTarget).val();
                if (!val || event.keyCode == 8) {
                    return;
                }
                const formattedName = val.toTitleCase();
                $(event.currentTarget).val(formattedName);
                this.GuestName(formattedName);
            };
            this.toJsObject = () => {
                var self = this;
                const copy = {
                    FirstName: self.FirstName(),
                    LastName: self.LastName(),
                    Phone: self.Phone(),
                    Email: self.Email(),
                    RenterCommentsAndQuestions: self.RenterCommentsAndQuestions(),
                    MoveInDate: self.MoveInDate(),
                    RequireEmailOrPhone: self.RequireEmailOrPhone()
                };
                return copy;
            };
        }
    }
    ils.GuestCardInfo = GuestCardInfo;
    class Roommate {
        constructor(item) {
            if (!item) {
                item = {};
            }
            this.RoommateLocalId = ko.observable(typeof (item.RoommateLocalId) == "undefined" || item.RoommateLocalId == null || parseInt(item.RoommateLocalId.toString()) === NaN ? Helpers.getRandomInt() : item.RoommateLocalId);
            this.RoommateOrder = ko.observable(typeof (item.RoommateOrder) == "undefined" || item.RoommateOrder == null || parseInt(item.RoommateOrder.toString()) === NaN ? 0 : item.RoommateOrder);
            this.GuestInfo = !item.GuestInfo ? new GuestCardInfo() : item.GuestInfo;
            this.RoommateTitle = ko.computed(() => {
                return `Roommate ${this.RoommateOrder()}`;
            });
        }
        CloseRoommate() {
            if (!ils.viewModel || !ils.viewModel.ProspectForm.RemoveRoommate) {
                return;
            }
            ils.viewModel.ProspectForm.RemoveRoommate(this.RoommateLocalId());
        }
        ;
    }
    ils.Roommate = Roommate;
})(ils || (ils = {}));

var ils;
(function (ils) {
    class PageTiming {
        constructor(itemName) {
            this.name = itemName;
            this.timeDuration = 0;
            this.startTime = null;
            this.endTime = null;
            this.startTracking = () => {
                this.startTime = new Date();
            };
            this.stopTracking = () => {
                this.endTime = new Date();
                var timeSpent = this.startTime == null || typeof (this.startTime) == 'undefined' ? 0 : this.endTime - this.startTime;
                var hourInMillis = 1000 * 60 * 60;
                if (timeSpent > 0 && timeSpent < hourInMillis)
                    this.timeDuration += timeSpent;
                this.startTime = null;
                this.endTime = null;
            };
            this.isCurrentlyTracking = () => {
                return this.startTime != null && this.endTime == null;
            };
        }
    }
    ils.PageTiming = PageTiming;
})(ils || (ils = {}));

var ils;
(function (ils) {
    function loadApartmentMapScripts(callback) {
        if (ils.googleDynamicMapsIsLoading) {
            return;
        }
        ils.googleDynamicMapsIsLoading = true;
        let googleMapsScript = document.createElement('script');
        let infoBoxScript = document.createElement('script');
        googleMapsScript.setAttribute("src", `https://maps.googleapis.com/maps/api/js?key=${ils.googleMapsKey}&libraries=geometry`);
        infoBoxScript.setAttribute("src", "/tft-js/fallback/infobox.js");
        googleMapsScript.onload = () => {
            document.body.appendChild(infoBoxScript);
            ils.mapCenter = new google.maps.LatLng(ils.googleMapsLat, ils.googleMapsLong);
            ils.googleMapsApiLoaded = true;
        };
        infoBoxScript.onload = () => {
            if (callback) {
                callback();
            }
            ils.googleDynamicMapsIsLoading = false;
            ils.googleDynamicMapsLoaded = true;
            ils.infoBoxLoaded = true;
        };
        // It's possible that we have already loaded the google maps api. If so we skip loading it here and just load the info-box script
        if (!ils.googleMapsApiLoaded) {
            document.body.appendChild(googleMapsScript);
        }
        else if (!ils.infoBoxLoaded) {
            document.body.appendChild(infoBoxScript);
        }
    }
    ils.loadApartmentMapScripts = loadApartmentMapScripts;
    function loadApartmentStaticMapScripts(callback) {
        if (ils.googleMapsApiLoaded || ils.googleDynamicMapsIsLoading) {
            if (callback && !ils.googleDynamicMapsIsLoading) {
                callback();
            }
            return;
        }
        ils.googleDynamicMapsIsLoading = true;
        let googleMapsScript = document.createElement('script');
        googleMapsScript.setAttribute("src", `https://maps.googleapis.com/maps/api/js?key=${ils.googleMapsKey}&libraries=geometry`);
        googleMapsScript.onload = () => {
            ils.mapCenter = new google.maps.LatLng(ils.googleMapsLat, ils.googleMapsLong);
            ils.googleMapsApiLoaded = true;
            if (callback) {
                callback();
            }
            ils.googleDynamicMapsIsLoading = false;
        };
        document.body.appendChild(googleMapsScript);
    }
    ils.loadApartmentStaticMapScripts = loadApartmentStaticMapScripts;
})(ils || (ils = {}));

var ils;
(function (ils) {
    var iLSHelpers = Helpers;
    const metaOverlayRootId = "ils-meta-lead-overlay";
    const metaOverlayDimClass = "ils-meta-lead-cdp-dim";
    const metaBodyLockClass = "ils-meta-lead-overlay-open";
    const metaOverlayDateInputClass = "ils-meta-lead-overlay__date-input";
    const metaOverlayDateWrapClass = "ils-meta-lead-overlay__date-wrap";
    const metaOverlayFormContactTypeID = 6;
    function metaOverlayDateFieldHtml(id, name, extraAttrs = "") {
        return (`<div class="${metaOverlayDateWrapClass} ils-meta-lead-overlay__date-wrap--empty">` +
            `<input id="${id}" name="${name}" type="date" class="${metaOverlayDateInputClass}" ${extraAttrs} />` +
            `<span class="ils-meta-lead-overlay__date-hint" aria-hidden="true">mm/dd/yyyy</span>` +
            `</div>`);
    }
    function syncMetaOverlayDatePlaceholder(input) {
        if (!input) {
            return;
        }
        const wrap = input.closest(`.${metaOverlayDateWrapClass}`);
        if (!wrap) {
            return;
        }
        wrap.classList.toggle("ils-meta-lead-overlay__date-wrap--empty", !input.value);
    }
    function isMetaOverlayMobileLayout() {
        return typeof globalThis.breakpoint === "function" && globalThis.breakpoint() === "mobile";
    }
    let savedViewportMetaContent = null;
    function lockViewportPinchZoomForOverlay() {
        if (!isMetaOverlayMobileLayout()) {
            return;
        }
        const meta = document.querySelector('meta[name="viewport"]');
        if (!meta) {
            return;
        }
        if (savedViewportMetaContent === null) {
            savedViewportMetaContent = meta.getAttribute("content") || "";
        }
        const withViewportFit = /viewport-fit\s*=\s*cover/i.test(savedViewportMetaContent);
        let locked = "width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no";
        if (withViewportFit) {
            locked += ", viewport-fit=cover";
        }
        meta.setAttribute("content", locked);
    }
    function unlockViewportPinchZoomForOverlay() {
        if (savedViewportMetaContent === null) {
            return;
        }
        const meta = document.querySelector('meta[name="viewport"]');
        if (meta) {
            meta.setAttribute("content", savedViewportMetaContent);
        }
        savedViewportMetaContent = null;
    }
    function pinOverlayMobileFrame(overlayRoot) {
        if (!isMetaOverlayMobileLayout()) {
            return;
        }
        overlayRoot.classList.add("ils-meta-lead-overlay--mobile-fixed");
        overlayRoot.style.width = `${window.innerWidth}px`;
        overlayRoot.style.height = `${window.innerHeight}px`;
        overlayRoot.style.top = "0";
        overlayRoot.style.left = "0";
    }
    function unpinOverlayMobileFrame(overlayRoot) {
        overlayRoot.classList.remove("ils-meta-lead-overlay--mobile-fixed");
        overlayRoot.style.width = "";
        overlayRoot.style.height = "";
        overlayRoot.style.top = "";
        overlayRoot.style.left = "";
    }
    function blockOverlayPinchGesture(e) {
        e.preventDefault();
    }
    function getAppRoot() {
        const w = typeof window !== "undefined" ? window : null;
        if (w && typeof w.baseUrl === "string" && w.baseUrl.length > 0) {
            return w.baseUrl;
        }
        return "/";
    }
    function showcaseMvcApiUrl(action) {
        const a = action.replace(/^\/+/, "");
        return `${getAppRoot()}mvc-api/showcase/${a}`;
    }
    function escapeHtml(raw) {
        return raw
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;");
    }
    function splitGuestName(full) {
        const t = (full || "").trim().replace(/\s+/g, " ");
        if (!t) {
            return { firstName: "", lastName: "" };
        }
        const i = t.indexOf(" ");
        if (i < 0) {
            return { firstName: t, lastName: "" };
        }
        return { firstName: t.slice(0, i), lastName: t.slice(i + 1).trim() };
    }
    /** Match GuestCardInfo / knockout.ils.extenders phoneiLS (digits after space strip). */
    const metaLeadPhoneIlsPattern = /^(1-?)?(\([2-9]\d{2}\)|[2-9]\d{2})-?[2-9]\d{2}-?\d{4}$/;
    const metaLeadValidationMessages = {
        nameRequired: "Please enter a full name.",
        nameFull: "Please enter your first name followed by your last name.",
        contactRequired: "Please enter a valid email address and/or a valid phone number",
        emailInvalid: "Please enter a valid email address.",
        phoneInvalid: "Please enter a valid phone number.",
        tourDate: "Please choose a tour date.",
        tourTime: "Please choose a tour time."
    };
    function metaLeadNormalizePhone(phone) {
        return (phone || "").replace(/\s+/g, "");
    }
    function metaLeadIsPhoneIlsValid(phone) {
        const p = metaLeadNormalizePhone(phone);
        if (!p) {
            return false;
        }
        return metaLeadPhoneIlsPattern.test(p);
    }
    function metaLeadIsEmailFormatOk(email) {
        const e = (email || "").trim();
        if (!e) {
            return false;
        }
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
    }
    function metaLeadIsGuestNameTwoParts(name) {
        const parts = name.trim().split(/\s+/).filter((x) => x.length > 0);
        return parts.length >= 2;
    }
    /** Same options as guest card `GuestCardInfo.formatPhone` / `#guestPhone`. */
    function metaOverlayFormatPhoneFieldValue(raw) {
        return iLSHelpers.formatPhone(raw, {
            allowExtensions: false,
            includeParenthesis: true,
            allowInternational: false
        });
    }
    function stripOverlayQueryParam() {
        try {
            const url = new URL(window.location.href);
            if (url.searchParams.get("overlay") !== "lead") {
                return;
            }
            url.searchParams.delete("overlay");
            history.replaceState({}, "", url.pathname + url.search + url.hash);
        }
        catch (_a) {
            /* ignore */
        }
    }
    function metaOverlayListingHrefFromAnchor(link) {
        if (!link) {
            return null;
        }
        const raw = (link.getAttribute("href") || link.href || "").trim();
        if (!raw || raw.startsWith("javascript:")) {
            return null;
        }
        try {
            const path = new URL(raw, window.location.origin).pathname;
            if (!path || path === "/" || /\/apartments\.aspx$/i.test(path)) {
                return null;
            }
            return path;
        }
        catch (_a) {
            return null;
        }
    }
    function joinMetaOverlayAppPath(pathname) {
        const path = pathname.startsWith("/") ? pathname : `/${pathname}`;
        const base = getAppRoot();
        if (!base || base === "/") {
            return path;
        }
        const baseTrimmed = base.replace(/\/$/, "");
        if (path.startsWith(baseTrimmed)) {
            return path;
        }
        return `${baseTrimmed}${path}`;
    }
    function resolveMetaOverlayApartmentSearchUrl() {
        var _a;
        const fromIls = (_a = ils.apartmentListingUrl) === null || _a === void 0 ? void 0 : _a.trim();
        if (fromIls) {
            const path = fromIls.startsWith("http")
                ? new URL(fromIls).pathname
                : fromIls.replace(/^~\//, "/");
            return joinMetaOverlayAppPath(path);
        }
        const candidates = [
            document.getElementById("uxBackToShowcase"),
            document.querySelector(".browse a.btn.btn-primary.with-arrow"),
            document.querySelector('a.btn.btn-primary.with-arrow[href*="-apartments"]'),
            document.getElementById("startSearch"),
            document.querySelector('a[href*="-apartments"]:not([href*="apartments.aspx"])')
        ];
        for (const link of candidates) {
            const path = metaOverlayListingHrefFromAnchor(link);
            if (path) {
                return joinMetaOverlayAppPath(path);
            }
        }
        const base = getAppRoot();
        return base.endsWith("/") ? base.slice(0, -1) || "/" : base;
    }
    function metaOverlayApartmentSearchTitle() {
        const location = (ils.communityName || ils.communityTitle || "").trim();
        if (location) {
            return `List of apartments in ${location}`;
        }
        return "Search apartments";
    }
    function metaOverlaySuccessBodyHtml(thanksCommunityEsc, searchHref) {
        const searchHrefEsc = escapeHtml(searchHref);
        const searchTitleEsc = escapeHtml(metaOverlayApartmentSearchTitle());
        return (`<p class="ils-meta-lead-overlay__thanks" role="status">` +
            `Thank you! ${thanksCommunityEsc} received your request and will be in touch soon.` +
            `</p>` +
            `<div class="ils-meta-lead-overlay__success-actions">` +
            `<a class="btn btn-primary with-arrow" href="${searchHrefEsc}" title="${searchTitleEsc}" id="ils-meta-search-more">` +
            `Search More Apartments <span class="ilsicon ilsicon-arrow-right"></span>` +
            `</a>` +
            `<button type="button" class="ils-meta-lead-overlay__btn-ghost" id="ils-meta-view-full">` +
            `See photos, pricing &amp; availability` +
            `</button>` +
            `</div>`);
    }
    function syncTourSlots(showcaseId) {
        const u = `${showcaseMvcApiUrl("sync-available-tour-time-slots")}?showcaseItemID=${showcaseId}`;
        void fetch(u, { method: "GET" }).catch(() => { });
    }
    function loadTourTimesForDate(showcaseId, ymd, selectEl) {
        if (!ymd) {
            selectEl.innerHTML = '<option value="">Select a date first</option>';
            selectEl.disabled = true;
            return;
        }
        const encoded = encodeURIComponent(`${ymd}T12:00:00`);
        const u = `${showcaseMvcApiUrl("get-available-tour-start-times")}?showcaseItemID=${showcaseId}&dateOfVisit=${encoded}`;
        selectEl.innerHTML = '<option value="">Loading…</option>';
        selectEl.disabled = true;
        fetch(u, { method: "GET" })
            .then((r) => r.json())
            .then((data) => {
            const slots = data && Array.isArray(data.d) ? data.d : [];
            const opts = ['<option value="">Select a time</option>'];
            for (let i = 0; i < slots.length; i++) {
                const s = slots[i];
                const esc = escapeHtml(s);
                opts.push(`<option value="${esc}">${esc}</option>`);
            }
            selectEl.innerHTML = opts.join("");
            selectEl.disabled = false;
        })
            .catch(() => {
            selectEl.innerHTML = '<option value="">Times unavailable</option>';
            selectEl.disabled = false;
        });
    }
    function contactTypeFromIntent(intent) {
        switch (intent) {
            case "tour":
                return 2;
            case "apply_now":
                return 5;
            default:
                return metaOverlayFormContactTypeID;
        }
    }
    /**
     * Lead intent → GTM form type string.
     * No chip selected → Overlay Form; chip values → Schedule a Tour | Apply Now.
     */
    function metaOverlayLeadFormType(intent) {
        switch (contactTypeFromIntent(intent)) {
            case 2:
                return ils.showcase.FormType.ScheduleTour;
            case 5:
                return ils.showcase.FormType.ApplyNow;
            default:
                return "Overlay Form";
        }
    }
    /** Same mapping from resolved `contactTypeID` (used after submit). */
    function metaOverlayLeadFormTypeFromContactTypeId(contactTypeID) {
        return metaOverlayLeadFormType(contactTypeID === 2
            ? "tour"
            : contactTypeID === 5
                ? "apply_now"
                : null);
    }
    /** Align submit payload URL with guest card: prefer `ils.communityUrl`, strip `overlay=lead` from current URL. */
    function metaOverlayAnalyticsCommunityUrl() {
        try {
            const raw = typeof ils.communityUrl === "string" && ils.communityUrl.length > 0 ? ils.communityUrl : window.location.href;
            const u = new URL(raw, window.location.origin);
            u.searchParams.delete("overlay");
            return u.toString();
        }
        catch (_a) {
            return typeof ils.communityUrl === "string" ? ils.communityUrl : window.location.href || "";
        }
    }
    function fireOverlaySubmitAnalytics(payloadData) {
        var _a, _b;
        const communityUrl = metaOverlayAnalyticsCommunityUrl();
        const trackingData = {
            communityName: payloadData.communityName,
            communityId: payloadData.showcaseItemID,
            formType: metaOverlayLeadFormTypeFromContactTypeId(payloadData.contactTypeID),
            unitType: ils.showRoommates ? ils.aptsforConstants.unitTypes.Student : ils.aptsforConstants.unitTypes.Conventional,
            communityUrl,
            numberOfRoommates: 0,
            floorPlans: "",
            moveInDate: payloadData.moveInDate,
            needsRoommate: payloadData.needsRoommate,
            preferredMoveIn: (_b = (_a = payloadData.preferredMoveIn) === null || _a === void 0 ? void 0 : _a.Name) !== null && _b !== void 0 ? _b : "",
            applyNowUrl: payloadData.contactTypeID === 5 ? ils.applyNowUrl || "" : ""
        };
        if (typeof TrackContactSubmit === "function") {
            TrackContactSubmit(trackingData);
        }
        if (payloadData.contactTypeID === 5 && typeof TrackShowcasePayPerClick === "function") {
            const ppc = globalThis.ppcActionType;
            if (ppc && ppc.applyNowUrl) {
                TrackShowcasePayPerClick(ppc.applyNowUrl, payloadData.showcaseItemID, payloadData.communityName, communityUrl);
            }
        }
        if (globalThis.abTestOverview != null && typeof TrackABConversion === "function") {
            TrackABConversion(globalThis.abOverviewName, globalThis.abTestOverview ? "main" : "alternate", payloadData.communityName, payloadData.showcaseItemID);
        }
        if (payloadData.contactTypeID === 2 && typeof TrackABView === "function") {
            TrackABView("ScheduleTourThanksView", globalThis.abTestVersion, payloadData.showcaseItemID, payloadData.communityName);
        }
    }
    function renderOverlayShell(root, communityTitle, showTourIntent, showApplyIntent) {
        const titleEsc = escapeHtml(communityTitle);
        const intentOptions = [];
        if (showTourIntent) {
            intentOptions.push(`<li class="intent-chip">` +
                `<input type="radio" name="ils-meta-intent" id="ils-meta-intent-tour" value="tour" />` +
                `<label for="ils-meta-intent-tour">Schedule a Tour</label>` +
                `</li>`);
        }
        if (showApplyIntent) {
            intentOptions.push(`<li class="intent-chip">` +
                `<input type="radio" name="ils-meta-intent" id="ils-meta-intent-apply" value="apply_now" />` +
                `<label for="ils-meta-intent-apply">Apply Now</label>` +
                `</li>`);
        }
        const intentBlock = intentOptions.length > 0
            ? `<fieldset class="ils-meta-lead-intent">` +
                `<legend>Next Step <span class="legend-optional">(optional)</span></legend>` +
                `<ul class="intent-chips" role="radiogroup" aria-label="Next step, optional. If none selected, your request is sent as an overlay form lead.">` +
                intentOptions.join("") +
                `</ul>` +
                `</fieldset>`
            : "";
        root.innerHTML =
            `<div class="ils-meta-lead-overlay__layout">` +
                `<div class="ils-meta-lead-overlay__layout-main">` +
                `<div class="ils-meta-lead-overlay__panel">` +
                `<header class="ils-meta-lead-overlay__header">` +
                `<h2 class="ils-meta-lead-overlay__title" id="ils-meta-lead-overlay-title">Send Me the Details</h2>` +
                `<img class="ils-meta-lead-overlay__logo" id="ils-meta-lead-overlay-logo" alt="" width="190" height="60" loading="lazy" decoding="async" />` +
                `</header>` +
                `<div class="ils-meta-lead-overlay__body" id="ils-meta-lead-overlay-body">` +
                `<p class="ils-meta-lead-overlay__error" id="ils-meta-lead-overlay-error" role="alert"></p>` +
                `<form class="ils-meta-lead-overlay__form" id="ils-meta-lead-overlay-form" novalidate>` +
                `<div class="ils-meta-lead-overlay__field">` +
                `<label for="ils-meta-name">What is your name?</label>` +
                `<input id="ils-meta-name" name="name" type="text" autocomplete="off" placeholder="First Last" />` +
                `<p class="ils-meta-lead-overlay__field-msg" id="ils-meta-msg-name" hidden></p>` +
                `</div>` +
                `<div class="ils-meta-lead-overlay__field">` +
                `<label for="ils-meta-email">Email</label>` +
                `<input id="ils-meta-email" name="email" type="text" autocomplete="email" placeholder="name@email.com" />` +
                `<p class="ils-meta-lead-overlay__field-msg" id="ils-meta-msg-email" hidden></p>` +
                `</div>` +
                `<div class="ils-meta-lead-overlay__field">` +
                `<label for="ils-meta-phone">Phone</label>` +
                `<input id="ils-meta-phone" name="phone" type="text" autocomplete="tel-national" placeholder="(XXX)XXX-XXXX" />` +
                `<p class="ils-meta-lead-overlay__field-msg" id="ils-meta-msg-phone" hidden></p>` +
                `</div>` +
                intentBlock +
                `<div id="ils-meta-intent-followup" class="intent-followup" hidden>` +
                `<div id="ils-meta-followup-tour" hidden>` +
                `<div class="ils-meta-lead-overlay__row ils-meta-lead-overlay__row--tour-datetime">` +
                `<div class="ils-meta-lead-overlay__field">` +
                `<label for="ils-meta-visit-date">Date of visit</label>` +
                metaOverlayDateFieldHtml("ils-meta-visit-date", "visitDate") +
                `<p class="ils-meta-lead-overlay__field-msg" id="ils-meta-msg-visit-date" hidden></p>` +
                `</div>` +
                `<div class="ils-meta-lead-overlay__field" id="ils-meta-visit-time-field" hidden>` +
                `<label for="ils-meta-visit-time">Time of visit</label>` +
                `<select id="ils-meta-visit-time" name="visitTimeSlot" disabled>` +
                `<option value="">Select a date first</option>` +
                `</select>` +
                `<p class="ils-meta-lead-overlay__field-msg" id="ils-meta-msg-visit-time" hidden></p>` +
                `</div>` +
                `</div>` +
                `</div>` +
                `</div>` +
                `<div class="ils-meta-lead-overlay__actions">` +
                `<button type="submit" class="ils-meta-lead-overlay__submit" id="ils-meta-submit">` +
                `<span id="ils-meta-submit-label">Submit to ${titleEsc}</span>` +
                `</button>` +
                `</div>` +
                `<p class="ils-meta-lead-overlay__footnote">` +
                `We will only use your info to help with your apartment search — it will be sent to the team so they can reach out directly.` +
                `</p>` +
                `</form>` +
                `</div>` +
                `</div>` +
                `</div>` +
                `<div class="ils-meta-lead-overlay__bottom-bar">` +
                `<p class="ils-meta-lead-overlay__bottom-hint" id="ils-meta-view-full-hint">Explore the full community page</p>` +
                `<button type="button" class="ils-meta-lead-overlay__btn-ghost" id="ils-meta-view-full" aria-describedby="ils-meta-view-full-hint">` +
                `See photos, pricing &amp; availability` +
                `</button>` +
                `</div>` +
                `</div>`;
        const logoEl = root.querySelector("#ils-meta-lead-overlay-logo");
        if (logoEl) {
            const headerLogo = document.querySelector(".body-content > .header .logo") ||
                document.getElementById("uxLogo");
            const src = headerLogo === null || headerLogo === void 0 ? void 0 : headerLogo.getAttribute("src");
            if (src) {
                logoEl.src = src;
            }
            else {
                logoEl.removeAttribute("src");
            }
            logoEl.alt = communityTitle || "Community";
        }
        const submitDefault = `Submit to ${communityTitle}`;
        const submitLabelEl = root.querySelector("#ils-meta-submit-label");
        const submitBtn = root.querySelector("#ils-meta-submit");
        const form = root.querySelector("#ils-meta-lead-overlay-form");
        const intentFollowup = root.querySelector("#ils-meta-intent-followup");
        const followTour = root.querySelector("#ils-meta-followup-tour");
        const visitDate = root.querySelector("#ils-meta-visit-date");
        const visitTimeField = root.querySelector("#ils-meta-visit-time-field");
        const visitTime = root.querySelector("#ils-meta-visit-time");
        const intentChips = root.querySelector(".intent-chips");
        const nameInput = root.querySelector("#ils-meta-name");
        const emailInput = root.querySelector("#ils-meta-email");
        const phoneInput = root.querySelector("#ils-meta-phone");
        const msgName = root.querySelector("#ils-meta-msg-name");
        const msgEmail = root.querySelector("#ils-meta-msg-email");
        const msgPhone = root.querySelector("#ils-meta-msg-phone");
        const msgVisitDate = root.querySelector("#ils-meta-msg-visit-date");
        const msgVisitTime = root.querySelector("#ils-meta-msg-visit-time");
        const errEl = root.querySelector("#ils-meta-lead-overlay-error");
        const showcaseId = ils.communityId;
        const formStartForOverlayTracked = new Set();
        let overlayDisplayed = false;
        let lastOverlayFormViewTracked = null;
        let overlaySessionStartMs = null;
        let overlayTimingFlushed = false;
        function getOverlayIntentFromForm() {
            const selected = form === null || form === void 0 ? void 0 : form.querySelector('input[name="ils-meta-intent"]:checked');
            return selected ? selected.value : null;
        }
        function trackOverlayFormViewIfChanged() {
            if (typeof ils.trackFormView !== "function") {
                return;
            }
            if (!overlayDisplayed) {
                return;
            }
            const ft = metaOverlayLeadFormType(getOverlayIntentFromForm());
            if (ft === lastOverlayFormViewTracked) {
                return;
            }
            lastOverlayFormViewTracked = ft;
            ils.trackFormView(ft, ils.communityName, ils.communityId);
        }
        function flushOverlayTiming(reason) {
            if (overlayTimingFlushed || overlaySessionStartMs == null) {
                return;
            }
            if (typeof ils.trackTimingEvent !== "function") {
                return;
            }
            const span = Math.min(Date.now() - overlaySessionStartMs, 600000);
            overlaySessionStartMs = null;
            overlayTimingFlushed = true;
            if (span > 0) {
                ils.trackTimingEvent("Meta Lead Overlay", reason, span, ils.communityName, ils.communityId);
            }
        }
        const applySubmitIconHtml = '<span id="ils-meta-submit-icon" class="interest-submit__trailing" aria-hidden="true">' +
            '<i class="ilsicon ilsicon-external-link" aria-hidden="true"></i></span>';
        function showError(msg) {
            if (!errEl) {
                return;
            }
            errEl.textContent = msg;
            errEl.classList.add("ils-meta-lead-overlay__error--visible");
        }
        function clearError() {
            if (!errEl) {
                return;
            }
            errEl.textContent = "";
            errEl.classList.remove("ils-meta-lead-overlay__error--visible");
        }
        const invalidInputClass = "ils-meta-lead-overlay__input--invalid";
        function clearOneField(input, msg) {
            input === null || input === void 0 ? void 0 : input.classList.remove(invalidInputClass);
            if (msg) {
                msg.textContent = "";
                msg.setAttribute("hidden", "");
            }
        }
        function setOneField(input, msg, message) {
            if (!input) {
                return;
            }
            input.classList.add(invalidInputClass);
            if (msg) {
                msg.textContent = message;
                msg.removeAttribute("hidden");
            }
        }
        function setInputInvalidOnly(input) {
            input === null || input === void 0 ? void 0 : input.classList.add(invalidInputClass);
        }
        function clearAllFieldErrors() {
            clearOneField(nameInput, msgName);
            clearOneField(emailInput, msgEmail);
            clearOneField(phoneInput, msgPhone);
            clearOneField(visitDate, msgVisitDate);
            clearOneField(visitTime, msgVisitTime);
        }
        function validateOverlayFields(contactTypeID) {
            const msgs = metaLeadValidationMessages;
            let ok = true;
            const fullName = ((nameInput === null || nameInput === void 0 ? void 0 : nameInput.value) || "").trim();
            if (!fullName) {
                setOneField(nameInput, msgName, msgs.nameRequired);
                ok = false;
            }
            else if (!metaLeadIsGuestNameTwoParts(fullName)) {
                setOneField(nameInput, msgName, msgs.nameFull);
                ok = false;
            }
            const emailVal = ((emailInput === null || emailInput === void 0 ? void 0 : emailInput.value) || "").trim();
            const phoneVal = (phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.value) || "";
            const phoneNorm = metaLeadNormalizePhone(phoneVal);
            if (!emailVal && !phoneNorm) {
                setInputInvalidOnly(emailInput);
                setInputInvalidOnly(phoneInput);
                if (msgEmail) {
                    msgEmail.textContent = msgs.contactRequired;
                    msgEmail.removeAttribute("hidden");
                }
                if (msgPhone) {
                    msgPhone.textContent = "";
                    msgPhone.setAttribute("hidden", "");
                }
                ok = false;
            }
            else {
                if (emailVal && !metaLeadIsEmailFormatOk(emailVal)) {
                    setOneField(emailInput, msgEmail, msgs.emailInvalid);
                    ok = false;
                }
                if (phoneNorm && !metaLeadIsPhoneIlsValid(phoneVal)) {
                    setOneField(phoneInput, msgPhone, msgs.phoneInvalid);
                    ok = false;
                }
            }
            if (contactTypeID === 2) {
                if (!hasValidVisitDate()) {
                    setOneField(visitDate, msgVisitDate, msgs.tourDate);
                    ok = false;
                }
                else if (!(visitTime === null || visitTime === void 0 ? void 0 : visitTime.value)) {
                    setOneField(visitTime, msgVisitTime, msgs.tourTime);
                    ok = false;
                }
            }
            return ok;
        }
        function wireFieldClearOnInput(input, msg) {
            input === null || input === void 0 ? void 0 : input.addEventListener("input", () => clearOneField(input, msg));
        }
        wireFieldClearOnInput(nameInput, msgName);
        wireFieldClearOnInput(emailInput, msgEmail);
        wireFieldClearOnInput(phoneInput, msgPhone);
        phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.addEventListener("keyup", (e) => {
            const val = phoneInput.value;
            if (!val || e.key === "Backspace" || e.keyCode === 8) {
                return;
            }
            const formatted = metaOverlayFormatPhoneFieldValue(val);
            if (formatted !== val) {
                phoneInput.value = formatted;
            }
        });
        phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.addEventListener("blur", () => {
            if (!(phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.value)) {
                return;
            }
            const formatted = metaOverlayFormatPhoneFieldValue(phoneInput.value);
            if (formatted !== phoneInput.value) {
                phoneInput.value = formatted;
            }
        });
        visitTime === null || visitTime === void 0 ? void 0 : visitTime.addEventListener("change", () => clearOneField(visitTime, msgVisitTime));
        nameInput === null || nameInput === void 0 ? void 0 : nameInput.addEventListener("focus", () => {
            if (typeof ils.trackFormStart !== "function") {
                return;
            }
            const ft = metaOverlayLeadFormType(getOverlayIntentFromForm());
            if (formStartForOverlayTracked.has(ft)) {
                return;
            }
            formStartForOverlayTracked.add(ft);
            ils.trackFormStart(ft, ils.communityName, ils.communityId);
        }, { passive: true });
        function syncSubmitButtonLabel() {
            if (!submitBtn || !submitLabelEl) {
                return;
            }
            const selected = form === null || form === void 0 ? void 0 : form.querySelector('input[name="ils-meta-intent"]:checked');
            const val = selected ? selected.value : null;
            submitLabelEl.textContent = val === "apply_now" ? "Continue to Online Application" : submitDefault;
            const iconWrap = document.getElementById("ils-meta-submit-icon");
            if (val === "apply_now") {
                if (!iconWrap && submitBtn) {
                    submitBtn.insertAdjacentHTML("beforeend", applySubmitIconHtml);
                }
            }
            else if (iconWrap) {
                iconWrap.remove();
            }
        }
        function hasValidVisitDate() {
            return !!((visitDate === null || visitDate === void 0 ? void 0 : visitDate.value) && visitDate.checkValidity());
        }
        function hideVisitTimeField() {
            visitTimeField === null || visitTimeField === void 0 ? void 0 : visitTimeField.setAttribute("hidden", "");
            if (visitTime) {
                visitTime.innerHTML = '<option value="">Select a date first</option>';
                visitTime.disabled = true;
            }
            clearOneField(visitTime, msgVisitTime);
        }
        function showVisitTimeField() {
            visitTimeField === null || visitTimeField === void 0 ? void 0 : visitTimeField.removeAttribute("hidden");
        }
        function syncIntentFollowup() {
            if (!form || !intentFollowup || !visitDate || !visitTime) {
                return;
            }
            const selected = form.querySelector('input[name="ils-meta-intent"]:checked');
            const val = selected ? selected.value : null;
            if (val === "tour") {
                intentFollowup.removeAttribute("hidden");
                followTour === null || followTour === void 0 ? void 0 : followTour.removeAttribute("hidden");
                visitDate.disabled = false;
                if (hasValidVisitDate()) {
                    showVisitTimeField();
                    loadTourTimesForDate(showcaseId, visitDate.value, visitTime);
                }
                else {
                    hideVisitTimeField();
                }
            }
            else {
                intentFollowup.setAttribute("hidden", "");
                followTour === null || followTour === void 0 ? void 0 : followTour.setAttribute("hidden", "");
                visitDate.disabled = true;
                visitDate.value = "";
                hideVisitTimeField();
                clearOneField(visitDate, msgVisitDate);
            }
            syncMetaOverlayDatePlaceholder(visitDate);
            syncSubmitButtonLabel();
            trackOverlayFormViewIfChanged();
        }
        function intentRadioFromTarget(node) {
            if (!node || !node.closest) {
                return null;
            }
            const chip = node.closest(".intent-chip");
            if (!chip) {
                return null;
            }
            return chip.querySelector('input[name="ils-meta-intent"]');
        }
        let intentPressRadio = null;
        let intentPressWasChecked = false;
        intentChips === null || intentChips === void 0 ? void 0 : intentChips.addEventListener("pointerdown", (e) => {
            const radio = intentRadioFromTarget(e.target);
            if (!radio) {
                return;
            }
            intentPressRadio = radio;
            intentPressWasChecked = radio.checked;
        });
        intentChips === null || intentChips === void 0 ? void 0 : intentChips.addEventListener("click", (e) => {
            const radio = intentRadioFromTarget(e.target);
            if (!radio) {
                return;
            }
            window.setTimeout(() => {
                if (intentPressRadio === radio && intentPressWasChecked && radio.checked) {
                    radio.checked = false;
                    intentPressRadio = null;
                    intentPressWasChecked = false;
                    syncIntentFollowup();
                    return;
                }
                intentPressRadio = null;
                intentPressWasChecked = false;
                syncIntentFollowup();
            }, 0);
        });
        visitDate === null || visitDate === void 0 ? void 0 : visitDate.addEventListener("change", () => {
            clearOneField(visitDate, msgVisitDate);
            if (visitDate && visitTime && (form === null || form === void 0 ? void 0 : form.querySelector("#ils-meta-intent-tour:checked"))) {
                clearOneField(visitTime, msgVisitTime);
                if (hasValidVisitDate()) {
                    showVisitTimeField();
                    loadTourTimesForDate(showcaseId, visitDate.value, visitTime);
                }
                else {
                    hideVisitTimeField();
                }
            }
        });
        syncIntentFollowup();
        [visitDate].forEach((dateInput) => {
            if (!dateInput) {
                return;
            }
            const syncDatePlaceholder = () => syncMetaOverlayDatePlaceholder(dateInput);
            dateInput.addEventListener("input", syncDatePlaceholder);
            dateInput.addEventListener("change", syncDatePlaceholder);
            syncDatePlaceholder();
        });
        const overlayBody = root.querySelector(".ils-meta-lead-overlay__body");
        let overlayViewportAttached = false;
        let savedPageScrollY = 0;
        function lockPageScrollForOverlay() {
            if (!isMetaOverlayMobileLayout()) {
                return;
            }
            savedPageScrollY = window.scrollY;
            document.body.style.top = `-${savedPageScrollY}px`;
            document.body.style.width = "100%";
            lockViewportPinchZoomForOverlay();
            pinOverlayMobileFrame(root);
        }
        function unlockPageScrollForOverlay() {
            if (!isMetaOverlayMobileLayout()) {
                return;
            }
            document.body.style.top = "";
            document.body.style.width = "";
            unlockViewportPinchZoomForOverlay();
            unpinOverlayMobileFrame(root);
            window.scrollTo(0, savedPageScrollY);
        }
        root.addEventListener("gesturestart", blockOverlayPinchGesture, { passive: false });
        root.addEventListener("gesturechange", blockOverlayPinchGesture, { passive: false });
        root.addEventListener("gestureend", blockOverlayPinchGesture, { passive: false });
        function syncOverlayToVisualViewport() {
            if (root.hasAttribute("hidden") || isMetaOverlayMobileLayout()) {
                return;
            }
            const vv = window.visualViewport;
            if (!vv) {
                return;
            }
            root.style.top = `${vv.offsetTop}px`;
            root.style.left = `${vv.offsetLeft}px`;
            root.style.width = `${vv.width}px`;
            root.style.height = `${vv.height}px`;
        }
        function attachOverlayViewport() {
            if (overlayViewportAttached) {
                return;
            }
            overlayViewportAttached = true;
            if (isMetaOverlayMobileLayout()) {
                return;
            }
            syncOverlayToVisualViewport();
            if (window.visualViewport) {
                window.visualViewport.addEventListener("resize", syncOverlayToVisualViewport);
                window.visualViewport.addEventListener("scroll", syncOverlayToVisualViewport);
            }
            window.requestAnimationFrame(() => syncOverlayToVisualViewport());
        }
        function detachOverlayViewport() {
            if (!overlayViewportAttached) {
                return;
            }
            overlayViewportAttached = false;
            if (isMetaOverlayMobileLayout()) {
                return;
            }
            if (window.visualViewport) {
                window.visualViewport.removeEventListener("resize", syncOverlayToVisualViewport);
                window.visualViewport.removeEventListener("scroll", syncOverlayToVisualViewport);
            }
            root.style.top = "";
            root.style.left = "";
            root.style.width = "";
            root.style.height = "";
        }
        function scrollFocusedFieldIntoOverlayBody(target) {
            if (!overlayBody || !target.matches("input, select, textarea")) {
                return;
            }
            window.setTimeout(() => {
                const targetRect = target.getBoundingClientRect();
                if (isMetaOverlayMobileLayout()) {
                    const vv = window.visualViewport;
                    if (!vv) {
                        return;
                    }
                    const visibleBottom = vv.offsetTop + vv.height;
                    const padding = 16;
                    if (targetRect.bottom > visibleBottom - padding) {
                        overlayBody.scrollTop += targetRect.bottom - visibleBottom + padding;
                    }
                    return;
                }
                const bodyRect = overlayBody.getBoundingClientRect();
                if (targetRect.top >= bodyRect.top && targetRect.bottom <= bodyRect.bottom) {
                    return;
                }
                target.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "auto" });
            }, 320);
        }
        if (overlayBody) {
            overlayBody.addEventListener("focusin", (e) => {
                scrollFocusedFieldIntoOverlayBody(e.target);
            });
        }
        const cdpRow = document.querySelector(".row.cdp");
        function hideOverlay() {
            flushOverlayTiming("dismissed");
            root.classList.add("ils-meta-lead-overlay--closing");
            cdpRow === null || cdpRow === void 0 ? void 0 : cdpRow.classList.remove(metaOverlayDimClass);
            document.body.classList.remove(metaBodyLockClass);
            unlockPageScrollForOverlay();
            window.setTimeout(() => {
                root.setAttribute("hidden", "");
                root.classList.remove("ils-meta-lead-overlay--closing");
                detachOverlayViewport();
            }, 250);
        }
        function showOverlay() {
            root.removeAttribute("hidden");
            root.classList.remove("ils-meta-lead-overlay--closing");
            cdpRow === null || cdpRow === void 0 ? void 0 : cdpRow.classList.add(metaOverlayDimClass);
            document.body.classList.add(metaBodyLockClass);
            lockPageScrollForOverlay();
            attachOverlayViewport();
            overlayDisplayed = true;
            overlaySessionStartMs = Date.now();
            overlayTimingFlushed = false;
            trackOverlayFormViewIfChanged();
            if (!isMetaOverlayMobileLayout() && nameInput) {
                try {
                    nameInput.focus({ preventScroll: true });
                }
                catch (_a) {
                    nameInput.focus();
                }
            }
        }
        function bindOverlayFooterActions() {
            const viewFullBtn = root.querySelector("#ils-meta-view-full");
            viewFullBtn === null || viewFullBtn === void 0 ? void 0 : viewFullBtn.addEventListener("click", () => {
                stripOverlayQueryParam();
                hideOverlay();
            });
            const searchMore = root.querySelector("#ils-meta-search-more");
            searchMore === null || searchMore === void 0 ? void 0 : searchMore.addEventListener("click", () => {
                stripOverlayQueryParam();
            });
        }
        bindOverlayFooterActions();
        root.addEventListener("click", (e) => {
            const target = e.target;
            if (target.closest(".ils-meta-lead-overlay__panel") || target.closest(".ils-meta-lead-overlay__bottom-bar")) {
                return;
            }
            hideOverlay();
        });
        form === null || form === void 0 ? void 0 : form.addEventListener("submit", (e) => {
            var _a, _b, _c;
            e.preventDefault();
            clearError();
            clearAllFieldErrors();
            const intentEl = form.querySelector('input[name="ils-meta-intent"]:checked');
            const intent = intentEl ? intentEl.value : null;
            const contactTypeID = contactTypeFromIntent(intent);
            if (contactTypeID === 5) {
                if (!ils.isApplyNowVisible || !ils.applyNowUrl) {
                    showError("Online application is not available for this community.");
                    return;
                }
            }
            if (!validateOverlayFields(contactTypeID)) {
                const firstInvalid = form.querySelector(`.${invalidInputClass}`) ||
                    form.querySelector(".ils-meta-lead-overlay__field-msg:not([hidden])");
                firstInvalid === null || firstInvalid === void 0 ? void 0 : firstInvalid.scrollIntoView({ block: "nearest", behavior: "smooth" });
                return;
            }
            const fullName = ((_a = document.getElementById("ils-meta-name")) === null || _a === void 0 ? void 0 : _a.value) || "";
            const { firstName, lastName } = splitGuestName(fullName);
            const emailAddress = ((_b = document.getElementById("ils-meta-email")) === null || _b === void 0 ? void 0 : _b.value) || "";
            const phone = ((_c = document.getElementById("ils-meta-phone")) === null || _c === void 0 ? void 0 : _c.value) || "";
            const dateOfVisit = contactTypeID === 2 && visitDate && visitTime ? `${visitDate.value} ${visitTime.value}`.trim() : "";
            if (!ils.cdpSessionId) {
                showError("Your session could not be verified. Please refresh the page and try again.");
                return;
            }
            const payloadData = {
                firstName,
                lastName,
                emailAddress,
                phone,
                moveInDate: "",
                preferredMoveIn: null,
                comments: "",
                showcaseItemID: ils.communityId,
                communityName: ils.communityName,
                contactTypeID,
                dateOfVisit,
                floorPlanIDs: [],
                hasRoommates: false,
                roommates: [],
                needsRoommate: false,
                cdpSessionId: ils.cdpSessionId,
                partialCaptureHangfireJobId: null
            };
            if (submitBtn) {
                submitBtn.disabled = true;
            }
            fetch(showcaseMvcApiUrl("submit-contact-form"), {
                method: "POST",
                headers: { "Content-Type": "application/json; charset=utf-8" },
                body: JSON.stringify(payloadData)
            })
                .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}`);
                }
                flushOverlayTiming("submitted");
                fireOverlaySubmitAnalytics({
                    contactTypeID,
                    communityName: ils.communityName,
                    showcaseItemID: ils.communityId,
                    moveInDate: "",
                    needsRoommate: false,
                    preferredMoveIn: null
                });
                if (contactTypeID === 5 && ils.applyNowUrl) {
                    window.open(ils.applyNowUrl, "_blank", "noopener,noreferrer");
                }
                const panel = root.querySelector(".ils-meta-lead-overlay__panel");
                if (panel && panel.offsetHeight > 0) {
                    panel.style.minHeight = `${panel.offsetHeight}px`;
                }
                root.classList.add("ils-meta-lead-overlay--success");
                const thanksCommunity = escapeHtml((ils.communityTitle || ils.communityName || "").trim() || "This community");
                const body = root.querySelector("#ils-meta-lead-overlay-body");
                if (body) {
                    body.innerHTML = metaOverlaySuccessBodyHtml(thanksCommunity, resolveMetaOverlayApartmentSearchUrl());
                    bindOverlayFooterActions();
                }
                const bottomBar = root.querySelector(".ils-meta-lead-overlay__bottom-bar");
                bottomBar === null || bottomBar === void 0 ? void 0 : bottomBar.setAttribute("hidden", "");
                if (submitBtn) {
                    submitBtn.style.display = "none";
                }
            })
                .catch(() => {
                showError("We could not submit your request. Please try again.");
                if (submitBtn) {
                    submitBtn.disabled = false;
                }
            });
        });
        showOverlay();
        syncTourSlots(showcaseId);
    }
    /**
     * When the CDP URL includes ?overlay=lead, show the Meta-style lead overlay (Instant Experience–style)
     * and POST to the same MVC endpoint used by the guest card.
     */
    function initMetaLeadCdpOverlayFromQuery() {
        let params;
        try {
            params = new URLSearchParams(window.location.search);
        }
        catch (_a) {
            return;
        }
        if (params.get("overlay") !== "lead") {
            return;
        }
        if (document.getElementById(metaOverlayRootId)) {
            return;
        }
        const communityTitle = (ils.communityTitle || ils.communityName || "").trim() || "this community";
        const showTourIntent = !!document.getElementById("ScheduleTourMenuItem");
        const showApplyIntent = !!(ils.isApplyNowVisible && ils.applyNowUrl);
        const root = document.createElement("div");
        root.id = metaOverlayRootId;
        root.setAttribute("role", "dialog");
        root.setAttribute("aria-modal", "true");
        root.setAttribute("aria-labelledby", "ils-meta-lead-overlay-title");
        document.body.appendChild(root);
        renderOverlayShell(root, communityTitle, showTourIntent, showApplyIntent);
    }
    ils.initMetaLeadCdpOverlayFromQuery = initMetaLeadCdpOverlayFromQuery;
})(ils || (ils = {}));

var ils;
(function (ils) {
    var maps = ils.ApartmentMaps;
    ils.trackedAdViews = [];
    ils.trackedImpressions = [];
    ils.primaryGuest = ils.primaryGuest || {};
    ils.showRoommates = ils.showRoommates || false;
    ils.floorPlanLoaded = false;
    ils.activeTabHash = "";
    ils.isSiteLive = ils.isSiteLive || false;
    ils.hasRoommates = ils.hasRoommates || false;
    ils.sessionRoommates = !ils.sessionRoommates ? [] : ils.sessionRoommates;
    ils.communityUrl = window.location.href || globalThis.currentURL;
    /** Friendly PFLP URL from SiteConstants (e.g. /tallahassee-apartments). */
    ils.apartmentListingUrl = "";
    /** CDP step-1 Hangfire abandonment flow; set true from apartment.aspx after apartment.min.js loads. */
    ils.enableCdpPartialCaptureHangfire = ko.observable(false);
    /** Must match FrontEnd.Master `var baseUrl = ResolveClientUrl("~/")` so MVC routes work under virtual directories. */
    function getAppBaseUrl() {
        const w = typeof window !== "undefined" ? window : null;
        if (w && typeof w.baseUrl === "string" && w.baseUrl.length > 0) {
            return w.baseUrl;
        }
        return "/";
    }
    function showcaseMvcApiUrl(action) {
        const a = action.replace(/^\/+/, "");
        return `${getAppBaseUrl()}mvc-api/showcase/${a}`;
    }
    var pageTimings = [];
    var currentTiming;
    // Guards SafeSendTimings so the page-lifecycle dispatch (beforeunload + pagehide + visibilitychange)
    // sends a single batch per page-load instead of duplicating events into GA4. The C# A/B report
    // averages `time_span * event_count / event_count`, so duplicates would skew the average.
    var timingsSent = false;
    var isAutoScrolling = false;
    var guestFormLayoutSyncTimer;
    /** Must match fixed .c-contact-form height in cdp-form.less (tallest guest-card step). */
    const guestCardInnerMinHeightPx = 627;
    /** Reserved band for progress + Back/Next so .c-guest-card-step height does not change per step (keep in sync with cdp-form.less). */
    const guestCardNavReservedPx = 240;
    /** Guest card wrapper under #ask-question — not the thank-you sibling `.contact-form`. */
    const cdpGuestCardShellSelector = "#ask-question > .contact-form.cdp-guest-card-shell";
    var allFloorPlansLoaded = false;
    var readMoreClicked = false;
    var shoppingDiningIsLoaded = false;
    var windowInactiveTime;
    var originalMoveInDate = null;
    // KO Validation setup
    const koValidationSettings = {
        insertMessages: true,
        messageTemplate: "customErrorTemplate",
        errorElementClass: 'error',
        errorsAsTitle: true,
        parseInputAttributes: false,
        messagesOnModified: false,
        decorateElementOnModified: true,
        decorateInputElement: true
    };
    ko.validation.init(koValidationSettings);
    let parsedRoommates = [];
    if (ils.sessionRoommates.length > 0) {
        ils.sessionRoommates.forEach((val, idx, roommates) => {
            if (!val) {
                return;
            }
            let roommate = new ils.Roommate({
                GuestInfo: new ils.GuestCardInfo({
                    Email: val.Email,
                    Phone: val.Phone,
                    FirstName: val.FirstName,
                    LastName: val.LastName,
                    RequireEmailOrPhone: false
                }),
                RoommateOrder: idx + 1
            });
            parsedRoommates.push(roommate);
        });
        ils.hasRoommates = true;
    }
    ils.viewModel = {
        FloorPlans: ko.observableArray([]),
        BedroomMin: ko.observable(window["bedroomMin"]),
        BedroomMax: ko.observable(window["bedroomMax"]),
        PriceMin: ko.observable(window["priceMin"]),
        PriceMax: ko.observable(window["priceMax"]),
        ProspectForm: new ils.ProspectFormData({ PrimaryGuest: new ils.GuestCardInfo(ils.primaryGuest), CommunityName: ils.communityTitle, CommunityId: ils.communityId, ShowRoommatesOption: ils.showRoommates, HasRoommates: ils.hasRoommates && ils.showRoommates, Roommates: parsedRoommates }),
        SubmittedContactTypes: ko.observableArray([]),
        HoursOpen: ko.observableArray([]),
        GetInfoButtonsVisible: ko.observable(false),
        IsApplyNowVisible: ko.observable(ils.isApplyNowVisible),
        ApplyNowUrl: ko.observable(ils.applyNowUrl),
        contactMenuHtml: ko.observable(`<span class="ilsicon ilsicon-mail"></span>&nbsp;Email`),
        getMoreInfoHtml: ko.observable(`<span class="ilsicon ilsicon-ask-bubbles"></span>&nbsp;Get More Information`),
        NeighborhoodMapContents: ko.observable(''),
        DirectionsMapContents: ko.observable(''),
        ActiveTabText: ko.observable(null),
        ReadyToSubmit: ko.observable(false),
        DateOfVisit: ko.observable(null),
        ClickedFeaturedCallToAction: ko.observable(null),
        PreferredMoveInTypes: ko.observableArray([]),
        PreferredMoveIn: ko.observable(null),
        MoveInDate: ko.observable(null),
        PartialCaptureHangfireJobId: ko.observable(null)
    };
    const trackedPartialCaptureCorrelationIds = new Set();
    function getPartialCaptureIntendedContactType(contactTypeId) {
        switch (contactTypeId) {
            case 2:
                return "Schedule Tour";
            case 3:
                return "Check Availability";
            case 1:
            default:
                return "Get More Info";
        }
    }
    function trackSubmittedPartialCaptureLead(intendedContactTypeID, correlationGuid) {
        if (!correlationGuid || trackedPartialCaptureCorrelationIds.has(correlationGuid)) {
            return;
        }
        trackedPartialCaptureCorrelationIds.add(correlationGuid);
        const formType = ils.aptsforConstants.contactFormTypes.Contact;
        const eventData = {
            intendedContactType: getPartialCaptureIntendedContactType(intendedContactTypeID),
            intendedContactTypeID,
            contactTypeID: ils.aptsforConstants.contactFormTypesIds.Contact
        };
        const contactSubmittalData = {
            formType,
            communityName: ils.communityName,
            communityId: ils.communityId,
            unitType: ils.showRoommates ? ils.aptsforConstants.unitTypes.Student : ils.aptsforConstants.unitTypes.Conventional,
            communityUrl: ils.communityUrl,
            numberOfRoommates: 0,
            floorPlans: "",
            moveInDate: "",
            needsRoommate: false,
            preferredMoveIn: "",
            ...eventData
        };
        ils.trackFormView(formType, ils.communityName, ils.communityId, eventData);
        ils.trackFormStart(formType, ils.communityName, ils.communityId, eventData);
        ils.trackStepFormNavigation(formType, ils.showcase.ViewType.NameInfo, 1, 1, ils.communityName, ils.communityId, eventData);
        TrackContactSubmit(contactSubmittalData);
    }
    function pollSubmittedPartialCaptureLead(intendedContactTypeID, correlationGuid, startedAt = Date.now()) {
        if (!correlationGuid || trackedPartialCaptureCorrelationIds.has(correlationGuid)) {
            return;
        }
        const maxWaitMs = 6 * 60 * 1000;
        const pollDelayMs = 15000;
        const statusUrl = `${showcaseMvcApiUrl("partial-contact-interest-status")}?cdpSessionId=${encodeURIComponent(ils.cdpSessionId)}&showcaseItemID=${encodeURIComponent(String(ils.communityId))}&correlationGuid=${encodeURIComponent(correlationGuid)}`;
        fetch(statusUrl, { method: "GET" })
            .then((r) => r.ok ? r.json() : null)
            .then((data) => {
            if (data && data.d && data.d.submitted) {
                trackSubmittedPartialCaptureLead(intendedContactTypeID, correlationGuid);
                return;
            }
            if (Date.now() - startedAt < maxWaitMs) {
                window.setTimeout(() => pollSubmittedPartialCaptureLead(intendedContactTypeID, correlationGuid, startedAt), pollDelayMs);
            }
        })
            .catch((err) => {
            if (typeof console !== "undefined" && console.warn) {
                console.warn("partial-contact-interest-status request error", err);
            }
            if (Date.now() - startedAt < maxWaitMs) {
                window.setTimeout(() => pollSubmittedPartialCaptureLead(intendedContactTypeID, correlationGuid, startedAt), pollDelayMs);
            }
        });
    }
    function schedulePartialCaptureAfterNameStep(prospectForm) {
        if (!ko.unwrap(ils.enableCdpPartialCaptureHangfire)) {
            return;
        }
        if (loggedIn) {
            return;
        }
        // CDP abandonment contact: Get More Info (1), Schedule Tour (2), Check Availability (3). Not Apply Now / specials.
        const ct = prospectForm.ContactTypeID();
        if (ct !== 1 && ct !== 2 && ct !== 3) {
            return;
        }
        const prev = ils.viewModel.PartialCaptureHangfireJobId();
        const guest = prospectForm.PrimaryGuest;
        const payload = {
            firstName: guest.FirstName(),
            lastName: guest.LastName(),
            emailAddress: guest.Email(),
            phone: guest.Phone(),
            showcaseItemID: ils.communityId,
            communityName: ils.communityName,
            intendedContactTypeID: prospectForm.ContactTypeID(),
            cdpSessionId: ils.cdpSessionId,
            requestUriString: typeof window !== "undefined" ? window.location.href : "",
            previousHangfireJobId: prev || null
        };
        fetch(showcaseMvcApiUrl("capture-partial-contact"), {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify(payload)
        })
            .then((r) => {
            if (!r.ok) {
                void r.text().then((t) => {
                    if (typeof console !== "undefined" && console.warn) {
                        console.warn("capture-partial-contact failed", r.status, t);
                    }
                });
                return null;
            }
            return r.json();
        })
            .then((data) => {
            const id = data && data.d && data.d.hangfireJobId;
            if (id) {
                ils.viewModel.PartialCaptureHangfireJobId(String(id));
                pollSubmittedPartialCaptureLead(payload.intendedContactTypeID, data.d.correlationGuid);
            }
        })
            .catch((err) => {
            if (typeof console !== "undefined" && console.warn) {
                console.warn("capture-partial-contact request error", err);
            }
        });
    }
    ils.schedulePartialCaptureAfterNameStep = schedulePartialCaptureAfterNameStep;
    ils.viewModel.ContactTitle = ko.computed(function () {
        return ils.viewModel.ProspectForm.ContactTypeID() == 1
            ? ils.askQuestionText
            : ils.viewModel.ProspectForm.ContactTypeID() == 2
                ? "Schedule a Tour"
                : ils.viewModel.ProspectForm.ContactTypeID() == 5
                    ? "Apply Online"
                    : "Check Availability";
    });
    ils.viewModel.FloorPlanPrices = ko.computed(function () {
        var tmpPrices = [];
        for (var i = 0; i < ils.viewModel.FloorPlans().length; i++) {
            var fp = ils.viewModel.FloorPlans()[i];
            if (fp.Price > 0)
                tmpPrices.push(fp.DisplayRate != null ? fp.DisplayRate : fp.Price);
        }
        if (tmpPrices.length === 0) {
            return [100, 2000];
        }
        tmpPrices = tmpPrices.sort(function (a, b) {
            return a < b ? -1 : a > b ? 1 : 0;
        });
        var prices = [tmpPrices[0], tmpPrices[tmpPrices.length - 1]];
        prices[0] = Math.floor(prices[0] / 50) * 50;
        prices[1] = Math.ceil(prices[1] / 50) * 50;
        return prices;
    });
    ils.viewModel.FloorPlanBedrooms = ko.computed(function () {
        var bedrooms = [];
        for (var i = 0; i < ils.viewModel.FloorPlans().length; i++) {
            bedrooms.push(ils.viewModel.FloorPlans()[i].NumberBedrooms);
        }
        if (bedrooms.length === 0) {
            return [0, 5];
        }
        return bedrooms.sort();
    });
    ils.viewModel.FiltersInUse = ko.computed(function () {
        return ils.viewModel.BedroomMin() != ils.viewModel.FloorPlanBedrooms()[0] || ils.viewModel.BedroomMax() != ils.viewModel.FloorPlanBedrooms()[ils.viewModel.FloorPlanBedrooms().length - 1] || ils.viewModel.PriceMin() != ils.viewModel.FloorPlanPrices()[0] || ils.viewModel.PriceMax() != ils.viewModel.FloorPlanPrices()[ils.viewModel.FloorPlanPrices().length - 1];
    });
    ils.viewModel.FilteredFloorPlans = ko.computed(function () {
        return ko.utils.arrayFilter(ils.viewModel.FloorPlans(), function (item) {
            return (
            // Check BedroomMin
            (ils.viewModel.BedroomMin() === null || ils.viewModel.BedroomMin() === undefined || item.NumberBedrooms >= ils.viewModel.BedroomMin()) &&
                // Check BedroomMax
                (ils.viewModel.BedroomMax() === null || ils.viewModel.BedroomMax() === undefined || item.NumberBedrooms <= ils.viewModel.BedroomMax()) &&
                // Check PriceMin / PriceMax against Display Rate (concession + fees)
                (ils.viewModel.PriceMin() === null || ils.viewModel.PriceMin() === undefined || (item.DisplayRate != null ? item.DisplayRate : item.Price) >= ils.viewModel.PriceMin() || item.Price == 0) &&
                (ils.viewModel.PriceMax() === null || ils.viewModel.PriceMax() === undefined || (item.DisplayRate != null ? item.DisplayRate : item.Price) <= ils.viewModel.PriceMax()));
        });
    });
    ils.viewModel.ScheduleTour = function () {
        navigateToScheduleTour();
    };
    ils.viewModel.ApplyNow = function () {
        navigateToApplyNow();
    };
    ils.viewModel.checkAvailabilityClick = function () {
        navigateToCheckAvailability();
    };
    ils.viewModel.ReadyToSubmit.subscribe((newVal) => {
        // We ignore the "Apply Online" contact type here because we have to handle that in a separate method
        // in order to forward the user onto the online application link
        if (!newVal || ils.viewModel.ProspectForm.ContactTypeID() === 5) {
            return;
        }
        //$(".contact-submit").click();
        ils.viewModel.SubmitContactForm();
    });
    ils.viewModel.ProspectForm.StepManager.ActiveView.subscribe((newVal) => {
        if (newVal === ils.showcase.ViewType.FloorPlans) {
            window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
                const floorPlanStep = document.querySelector(".c-guest-card-floor-plans");
                const initializer = globalThis.InitializeJCarousels;
                if (floorPlanStep && initializer) {
                    initializer(floorPlanStep, true);
                }
            }));
        }
        if (!newVal || newVal !== ils.showcase.ViewType.Comments) {
            return;
        }
        if (ils.viewModel.PreferredMoveInTypes().length > 1) {
            return;
        }
        // Add logic to set the move-in date based on what is selected
        fetch("/api/showcase/get-move-in-types")
            .then(response => response.json())
            .then((data) => {
            data.MoveInTypes.forEach((item, index) => {
                ils.viewModel.PreferredMoveInTypes.push(item);
            });
            if (!ils.viewModel.ProspectForm.StepManager.ShowRoommates()) {
                const customDateOption = ils.viewModel.PreferredMoveInTypes().find((opt) => {
                    return opt.Name.startsWith('Custom');
                });
                if (!(!customDateOption))
                    ils.viewModel.PreferredMoveIn(customDateOption);
            }
        })
            .catch(error => {
            console.error(`An error occurred while getting the Preferred Move In Types: ${error}`);
            let customDate = new ils.PreferredMoveInType({ Name: 'Custom Date', Id: 4, Description: '' });
            ils.viewModel.PreferredMoveInTypes.push(customDate);
            ils.viewModel.PreferredMoveIn(customDate);
        });
    });
    // KO step changes do not run shell sync; flex was still giving .c-guest-card-step a different height when
    // the nav block's intrinsic height changed (Schedule a Tour steps 1–4).
    ils.viewModel.ProspectForm.StepManager.ActiveView.subscribe(() => {
        if (globalThis.breakpoint() !== "mobile") {
            return;
        }
        const runLocks = () => {
            const panel = document.getElementById("ask-question");
            if (!panel || !$(panel).is(":visible")) {
                return;
            }
            const shell = document.querySelector(cdpGuestCardShellSelector);
            if (!shell || !$(shell).is(":visible")) {
                return;
            }
            ensureGuestCardMobileLockStyleInjected();
            applyGuestCardMobileStepNavLocks(shell);
        };
        window.requestAnimationFrame(() => window.requestAnimationFrame(runLocks));
        window.setTimeout(runLocks, 0);
        window.setTimeout(runLocks, 50);
    });
    ils.viewModel.PreferredMoveIn.subscribe((newVal) => {
        if (!ils.showRoommates) {
            return;
        }
        if (!originalMoveInDate) {
            originalMoveInDate = !(document.querySelector("#uxNewAvailabilityDate_uxDate").value)
                ? moment().add(1, 'M').format("MM/DD/YYYY")
                : document.querySelector("#uxNewAvailabilityDate_uxDate").value;
        }
        if (!newVal) {
            ils.viewModel.MoveInDate(null);
            document.querySelector("#uxNewAvailabilityDate_uxDate").value = "";
            return;
        }
        if (!newVal || newVal.Name.startsWith('Custom')) {
            ils.viewModel.MoveInDate(moment(originalMoveInDate).format("MM/DD/YYYY"));
            document.querySelector("#uxNewAvailabilityDate_uxDate").value = ils.viewModel.MoveInDate();
            return;
        }
        const now = moment();
        const currentYear = now.year();
        const nextYear = now.year() + 1;
        if (newVal.Name.startsWith('Fall')) {
            let moveIn = moment();
            if (newVal.Id < 100) {
                moveIn = now.isAfter(moment(`${currentYear}-08-15`))
                    ? moment(`${nextYear}-08-15`)
                    : moment(`${currentYear}-08-15`);
            }
            else {
                moveIn = now.isAfter(moment(`${currentYear}-08-15`))
                    ? moment(`${nextYear + 1}-08-15`)
                    : moment(`${nextYear}-08-15`);
            }
            ils.viewModel.MoveInDate(moveIn.format("MM/DD/YYYY"));
            document.querySelector("#uxNewAvailabilityDate_uxDate").value = ils.viewModel.MoveInDate();
            return;
        }
        if (newVal.Name.startsWith("Spring")) {
            let moveIn = moment();
            if (newVal.Id < 100) {
                moveIn = moment(`${nextYear}-01-01`);
            }
            else {
                moveIn = moment(`${nextYear + 1}-01-01`);
            }
            ils.viewModel.MoveInDate(moveIn.format("MM/DD/YYYY"));
            document.querySelector("#uxNewAvailabilityDate_uxDate").value = ils.viewModel.MoveInDate();
            return;
        }
        if (newVal.Name.startsWith("Immediate")) {
            let moveIn = moment().add(1, 'w');
            ils.viewModel.MoveInDate(moveIn.format("MM/DD/YYYY"));
            document.querySelector("#uxNewAvailabilityDate_uxDate").value = ils.viewModel.MoveInDate();
            return;
        }
    });
    ils.viewModel.SubmitApplyNowForm = function () {
        ils.viewModel.ProspectForm.OnNext();
        if (!ils.viewModel.ReadyToSubmit()) {
            return false;
        }
        ils.viewModel.SubmitContactForm();
        return true;
    };
    ils.viewModel.SubmitContactForm = function () {
        const returnVal = ils.viewModel.ProspectForm.ContactTypeID() === 5 && !(!ils.viewModel.ApplyNowUrl()) && ils.viewModel.IsApplyNowVisible();
        if (ils.viewModel.ProspectForm.SubmitHasBeenClicked() || !ils.viewModel.ReadyToSubmit())
            return returnVal;
        ils.viewModel.ProspectForm.SubmitHasBeenClicked(true);
        if (ils.viewModel.ProspectForm.IsFormValid()) {
            const { date: tourDate, time: tourTime } = ils.getScheduleTourDateTimeValues();
            const dateOfVisit = `${tourDate} ${tourTime}`.trim();
            ils.viewModel.DateOfVisit(dateOfVisit);
            if (ils.viewModel.ProspectForm.ContactTypeID() == 2) {
                const tourDateValidation = ils.validateOptionalTourDateTime(tourDate, tourTime);
                if (!tourDateValidation.isValid) {
                    ils.viewModel.ProspectForm.StepManager.TourDateValidationMessage(tourDateValidation.message);
                    ils.viewModel.ProspectForm.SubmitHasBeenClicked(false);
                    ils.viewModel.ReadyToSubmit(false);
                    const tourStep = ils.viewModel.ProspectForm.StepManager.ProgressSteps().find((step) => step.StepName() === ils.showcase.ViewType.TourDate);
                    if (tourStep) {
                        ils.viewModel.ProspectForm.StepManager.NavigateTo(tourStep);
                    }
                    return returnVal;
                }
                ils.viewModel.ProspectForm.StepManager.TourDateValidationMessage("");
            }
            // If the user selected to schedule a tour but did not enter in a date and time, then we don't want to submit a tour, just a check availability or email
            if (ils.viewModel.ProspectForm.ContactTypeID() == 2 && (ils.viewModel.DateOfVisit() === null || ils.viewModel.DateOfVisit().length < 2)) {
                if (ils.viewModel.ProspectForm.SelectedFloorPlans().length > 0) {
                    ils.viewModel.ProspectForm.ContactTypeID(3);
                }
                else {
                    ils.viewModel.ProspectForm.ContactTypeID(1);
                }
            }
            // Extract the data from the form
            const payloadData = {
                firstName: ils.viewModel.ProspectForm.PrimaryGuest.FirstName(),
                lastName: ils.viewModel.ProspectForm.PrimaryGuest.LastName(),
                emailAddress: ils.viewModel.ProspectForm.PrimaryGuest.Email(),
                phone: ils.viewModel.ProspectForm.PrimaryGuest.Phone(),
                moveInDate: $("#uxNewAvailabilityDate_uxDate").val(),
                preferredMoveIn: ils.viewModel.PreferredMoveIn(),
                comments: ils.viewModel.ProspectForm.StepManager.NeedRoommate()
                    ? `${ils.viewModel.ProspectForm.PrimaryGuest.RenterCommentsAndQuestions()} This renter has indicated they need roommate matching.`
                    : ils.viewModel.ProspectForm.PrimaryGuest.RenterCommentsAndQuestions(),
                showcaseItemID: ils.communityId,
                communityName: ils.communityName,
                contactTypeID: ils.viewModel.ProspectForm.ContactTypeID(),
                dateOfVisit: ils.viewModel.DateOfVisit(),
                floorPlanIDs: ils.viewModel.ProspectForm.SelectedFloorPlans(),
                hasRoommates: ils.viewModel.ProspectForm.StepManager.HasRoommates(),
                roommates: ils.viewModel.ProspectForm.StepManager.HasRoommates() ? ils.viewModel.ProspectForm.Roommates().map(r => r.GuestInfo.toJsObject()) : [],
                needsRoommate: ils.viewModel.ProspectForm.StepManager.NeedRoommate(),
                cdpSessionId: ils.cdpSessionId,
                partialCaptureHangfireJobId: ils.viewModel.PartialCaptureHangfireJobId() || null
            };
            var jsonData = JSON.stringify(payloadData);
            // extract the floor plan names so we can use them in statistics and analytics
            const selectedFloorPlanNames = ils.viewModel.ProspectForm.SelectedFloorPlans().map((floorPlanId) => {
                let floorPlan = ils.viewModel.FloorPlans().find(fpx => fpx.FloorPlanID === floorPlanId);
                return !floorPlan ? 'null' : floorPlan.Name;
            });
            // Thank-you visibility is bound to SubmittedContactTypes; update as soon as we post so the UI
            // does not wait on network latency before swapping the form for the thank-you state.
            ils.viewModel.SubmittedContactTypes.push(ils.viewModel.ProspectForm.ContactTypeID());
            // Mobile sync sets inline height on the guest shell; clear it (thank-you uses a sibling .contact-form).
            clearGuestContactFormShellLayout();
            window.setTimeout(() => scrollContactFormIntoView(), 0);
            // We have to use the "mvc-api" endpoint here (instead of Web API) because the code processing this POST relies on SessionState and
            // WebAPI does not have access to session state (easily).  *sigh*
            var contactUrl = showcaseMvcApiUrl("submit-contact-form");
            fetch(contactUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: jsonData
            })
                .then((response) => {
                if (response.ok && payloadData.partialCaptureHangfireJobId) {
                    ils.viewModel.PartialCaptureHangfireJobId(null);
                }
                // Do not await the body: keep UX/analytics the same as pre–partial-capture (POST is in flight; no wait on JSON parse).
                void response.text().catch(() => { });
            })
                .catch((error) => {
                console.error('SubmitContactForm failed', error);
            });
            submitContactFormResponse(payloadData, selectedFloorPlanNames);
            ils.viewModel.ReadyToSubmit(false);
        }
        else {
            ils.viewModel.ProspectForm.SubmitHasBeenClicked(false);
            ils.viewModel.ReadyToSubmit(false);
        }
        function submitContactFormResponse(payloadData, selectedFloorPlanNames) {
            var _a, _b;
            const trackingData = {
                communityName: payloadData.communityName,
                communityId: payloadData.showcaseItemID,
                formType: ils.aptsforConstants.getContactFormTypeFromId(payloadData.contactTypeID),
                unitType: ils.showRoommates ? ils.aptsforConstants.unitTypes.Student : ils.aptsforConstants.unitTypes.Conventional,
                communityUrl: ils.communityUrl,
                numberOfRoommates: ils.showRoommates ? payloadData.roommates.length : 0,
                floorPlans: selectedFloorPlanNames ? selectedFloorPlanNames.join('; ').trim() : '',
                moveInDate: payloadData.moveInDate,
                needsRoommate: payloadData.needsRoommate,
                preferredMoveIn: (_b = (_a = payloadData.preferredMoveIn) === null || _a === void 0 ? void 0 : _a.Name) !== null && _b !== void 0 ? _b : '',
                applyNowUrl: payloadData.contactTypeID === 5 ? ils.viewModel.ApplyNowUrl() : ''
            };
            TrackContactSubmit(trackingData);
            if (payloadData.hasRoommates && payloadData.roommates && payloadData.roommates.length > 0) {
                payloadData.roommates.forEach(() => {
                    console.log(payloadData);
                    TrackContactSubmit(trackingData);
                });
            }
            if (payloadData.contactTypeID === 5) {
                TrackShowcasePayPerClick(globalThis.ppcActionType.applyNowUrl, ils.communityId, ils.communityName, ils.communityUrl);
            }
            if (globalThis.abTestOverview != null)
                TrackABConversion(globalThis.abOverviewName, globalThis.abTestOverview ? "main" : "alternate", payloadData.communityName, payloadData.showcaseItemID);
            if (ils.viewModel.ProspectForm.ContactTypeID() == 2)
                TrackABView("ScheduleTourThanksView", globalThis.abTestVersion, ils.communityId, payloadData.communityName);
        }
        return returnVal;
    };
    function getHoursOpen(dateOfVisit) {
        fetch(`${globalThis.baseUrl}mvc-api/showcase/get-available-tour-start-times?showcaseItemID=${ils.communityId}&dateOfVisit=${dateOfVisit}`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => {
            ils.viewModel.HoursOpen(data.d);
        })
            .catch(error => console.error(error));
    }
    function ToggleContactMenuABTest(testCase = "a") {
        if (testCase !== "a") {
            ils.viewModel.contactMenuHtml(`<span class="ilsicon ilsicon-ask-bubbles"></span>&nbsp;Next Steps`);
            ils.viewModel.getMoreInfoHtml(`<span class="ilsicon ilsicon-mail"></span>&nbsp;Get More Information`);
        }
        else {
            ils.viewModel.contactMenuHtml(`<span class="ilsicon ilsicon-mail"></span>&nbsp;Email`);
            ils.viewModel.getMoreInfoHtml(`<span class="ilsicon ilsicon-ask-bubbles"></span>&nbsp;Get More Information`);
        }
    }
    ils.ToggleContactMenuABTest = ToggleContactMenuABTest;
    function AddCommas(number) {
        const parts = String(number).split('.');
        let intPart = parts[0];
        // Preserve leading minus for negative values
        const sign = intPart.charAt(0) === '-' ? '-' : '';
        if (sign)
            intPart = intPart.substring(1);
        for (var i = 0; i < Math.floor((intPart.length - (1 + i)) / 3); i++)
            intPart = intPart.substring(0, intPart.length - (4 * i + 3)) + ',' + intPart.substring(intPart.length - (4 * i + 3));
        return sign + intPart + (parts.length > 1 ? '.' + parts[1] : '');
    }
    ils.AddCommas = AddCommas;
    function ToggleSelectedFloorPlan(floorPlanID) {
        if ($.inArray(floorPlanID, ils.viewModel.ProspectForm.SelectedFloorPlans()) == -1)
            ils.viewModel.ProspectForm.SelectedFloorPlans.push(floorPlanID);
        else
            ils.viewModel.ProspectForm.SelectedFloorPlans(ko.utils.arrayFilter(ils.viewModel.ProspectForm.SelectedFloorPlans(), function (item) {
                return item != floorPlanID;
            }));
    }
    ils.ToggleSelectedFloorPlan = ToggleSelectedFloorPlan;
    function askQuestionMobile(contactTypeId, isFeaturedCallToAction = false) {
        if (!contactTypeId) {
            return;
        }
        ils.viewModel.ProspectForm.ContactTypeID(contactTypeId);
        switch (contactTypeId) {
            case 1:
                ils.viewModel.ActiveTabText("Get MoreInformation"); // We have no space between 'More' and 'Information' to keep it consistent with how we originally set it up and align with historical data on Google Analytics
                // If we have a featured call to action and it's the first time being clicked then log this to google analytics
                if (isFeaturedCallToAction && !ils.viewModel.ClickedFeaturedCallToAction()) {
                    ils.viewModel.ClickedFeaturedCallToAction(ils.viewModel.ActiveTabText());
                    gaTrackFeaturedCallToAction(ils.viewModel.ClickedFeaturedCallToAction(), globalThis.showcaseItemID, ils.communityTitle);
                }
                break;
            case 2:
                ils.viewModel.ActiveTabText("Schedule a Tour");
                // If we have a featured call to action and it's the first time being clicked then log this to google analytics
                if (isFeaturedCallToAction && !ils.viewModel.ClickedFeaturedCallToAction()) {
                    ils.viewModel.ClickedFeaturedCallToAction(ils.viewModel.ActiveTabText());
                    gaTrackFeaturedCallToAction(ils.viewModel.ClickedFeaturedCallToAction(), globalThis.showcaseItemID, ils.communityTitle);
                }
                break;
            case 3:
                ils.viewModel.ActiveTabText("Check Availability");
                // If we have a featured call to action and it's the first time being clicked then log this to google analytics
                if (isFeaturedCallToAction && !ils.viewModel.ClickedFeaturedCallToAction()) {
                    ils.viewModel.ClickedFeaturedCallToAction(ils.viewModel.ActiveTabText());
                    gaTrackFeaturedCallToAction(ils.viewModel.ClickedFeaturedCallToAction(), globalThis.showcaseItemID, ils.communityTitle);
                }
                break;
            case 5:
                ils.viewModel.ActiveTabText("Apply Online");
                // If we have a featured call to action and it's the first time being clicked then log this to google analytics
                if (isFeaturedCallToAction && !ils.viewModel.ClickedFeaturedCallToAction()) {
                    ils.viewModel.ClickedFeaturedCallToAction(ils.viewModel.ActiveTabText());
                    gaTrackFeaturedCallToAction(ils.viewModel.ClickedFeaturedCallToAction(), globalThis.showcaseItemID, ils.communityTitle);
                }
                break;
            default:
                ils.viewModel.ActiveTabText("Get MoreInformation");
                // If we have a featured call to action and it's the first time being clicked then log this to google analytics
                if (isFeaturedCallToAction && !ils.viewModel.ClickedFeaturedCallToAction()) {
                    ils.viewModel.ClickedFeaturedCallToAction(ils.viewModel.ActiveTabText());
                    gaTrackFeaturedCallToAction(ils.viewModel.ClickedFeaturedCallToAction(), globalThis.showcaseItemID, ils.communityTitle);
                }
                break;
        }
        var timeout = setTimeout(function () {
            $("#contact-menu").removeClass("in");
            $("#contact-menu").css("height", "20px");
            clearTimeout(timeout);
        }, 250);
    }
    ils.askQuestionMobile = askQuestionMobile;
    function checkAvailability(currentFloorPlan, e) {
        if (!currentFloorPlan) {
            return;
        }
        navigateToCheckAvailability();
        //$('.cdp-menu a[href="#ask-question"]').click();
        ToggleSelectedFloorPlan(currentFloorPlan.FloorPlanID);
    }
    ils.checkAvailability = checkAvailability;
    function BindPriceSlider() {
        var sliderElement = $("#uxPriceRangeSlider");
        var values = ils.viewModel.FloorPlanPrices();
        var value1 = globalThis.priceMin && globalThis.priceMin > values[0] ? globalThis.priceMin : values[0];
        var value2 = globalThis.priceMax && globalThis.priceMax < values[values.length - 1] ? globalThis.priceMax : values[values.length - 1];
        sliderElement.slider({
            range: true,
            step: 50,
            min: values[0],
            max: values[values.length - 1],
            values: [value1, value2],
            create: function (event, ui) {
                if (sliderElement.find(".handle-text").length == 0)
                    sliderElement.find(".ui-slider-handle").append('<span class="handle-text"></span>');
                sliderElement.find(".ui-slider-handle:last").addClass("reverse");
                UnstackSliderLabels(sliderElement.find(".ui-slider-handle:" + (value2 == values[0] ? "last" : "first")), value1, value2);
                priceSliderUpdateFilter(sliderElement);
            },
            slide: function (event, ui) {
                var handle = $(ui.handle);
                handle.find(".handle-text").html("$" + ui.value);
                UnstackSliderLabels(handle, ui.values[0], ui.values[1]);
            },
            stop: function (event, ui) {
                priceSliderUpdateFilter(sliderElement);
            }
        });
        sliderElement.find(".handle-text:first").html("$" + value1);
        sliderElement.find(".handle-text:last").html("$" + value2);
    }
    ils.BindPriceSlider = BindPriceSlider;
    function FixHeightsAfterImagesLoaded(element) {
        $(element).imagesLoaded().always(function () {
            globalThis.SetDynamicElements($(element).parent());
        });
    }
    // Tab text comes straight from the DOM (e.g. `$(".cdp-menu .active a").text()`) and can include
    // newlines and runs of whitespace depending on how each regional site marks up its tab links
    // (e.g. "Overview\n                                        & Photos"). The C# A/B timing report
    // matches on this value, so we collapse runs of whitespace to a single space and trim. This
    // also keeps the GA4 dimension values readable in the admin UI.
    function normalizeTabName(tabName) {
        return (tabName !== null && tabName !== void 0 ? tabName : "").replace(/\s+/g, " ").trim();
    }
    function TrackTimeForNewTab(tabName) {
        tabName = normalizeTabName(tabName);
        if (currentTiming)
            currentTiming.stopTracking();
        var previousTiming = ko.utils.arrayFirst(pageTimings, function (item) {
            return item.name == tabName;
        });
        if (previousTiming)
            currentTiming = previousTiming;
        else
            currentTiming = new ils.PageTiming(tabName);
        currentTiming.startTracking();
        if (!previousTiming)
            pageTimings.push(currentTiming);
    }
    function SendTimings() {
        if (globalThis.hasRoles || !ils.isSiteLive)
            return;
        currentTiming.stopTracking();
        for (var i = 0; i < pageTimings.length; i++) {
            if (pageTimings[i].timeDuration > 0) {
                ils.trackTimingEvent("CDP Tab", pageTimings[i].name, Math.min(pageTimings[i].timeDuration, 600000), ils.communityName, ils.communityId); //Don't allow for more than 10 minutes per tab (idle)
                if (globalThis.abTestOverview != null) {
                    ils.trackTimingEvent("ABCDP Tab" + (globalThis.abTestOverview ? "main" : "alternate"), pageTimings[i].name, Math.min(pageTimings[i].timeDuration, 600000), ils.communityName, ils.communityId); //Don't allow for more than 10 minutes per tab (idle)
                }
            }
        }
        for (let i = 0; i < ils.viewModel.ProspectForm.StepManager.ProgressSteps().length; i++) {
            let step = ils.viewModel.ProspectForm.StepManager.ProgressSteps()[i];
            step.StepTiming.stopTracking();
            if (!step || step.StepTiming.timeDuration <= 0) {
                continue;
            }
            let timeDuration = Math.min(step.StepTiming.timeDuration, 600000); // Max 10 minutes so we don't count idle time
            ils.trackTimingEvent("Form Step", step.StepTiming.name, timeDuration, ils.communityName, ils.communityId);
            //ga('send', 'timing', 'Form Step', step.StepTiming.name, timeDuration);
            if (!ils.isSiteLive) {
                console.log(`Total time sent to Google Analytics for ${step.StepName} is ${timeDuration.toString()}`);
            }
        }
    }
    // SendTimings used to be wired only to `beforeunload`, which is unreliable -- it does not fire
    // on Chrome/Safari mobile when the tab is reclaimed, and browsers cancel pending requests
    // mid-unload, so most "Overview" tab timings never reached GA4. That's why the A/B admin grid
    // showed 0% improvement on overview tests for so long. This wrapper:
    //   1. Runs at most once per page lifecycle (avoids GA4 event duplication that would skew the
    //      C# `mainTotalTime / mainEventCount` average).
    //   2. Is dispatched from `pagehide` and `visibilitychange === "hidden"` (in addition to the
    //      legacy `beforeunload`) so the timing payload survives mobile backgrounding and bfcache.
    function SafeSendTimings() {
        if (timingsSent) {
            return;
        }
        timingsSent = true;
        try {
            SendTimings();
            ils.viewModel.ProspectForm.StepManager.SendFormCompletionMetrics(ils.viewModel.ProspectForm.SubmitHasBeenClicked());
        }
        catch (e) {
            console.error("[SafeSendTimings] failed", e);
        }
    }
    function focusContactFormLandmark(element) {
        const hadTabindex = element.hasAttribute("tabindex");
        if (!hadTabindex) {
            element.setAttribute("tabindex", "-1");
        }
        try {
            element.focus({ preventScroll: true });
        }
        catch (_a) {
            element.focus();
        }
        if (!hadTabindex) {
            element.addEventListener("blur", function removeTabindex() {
                element.removeAttribute("tabindex");
                element.removeEventListener("blur", removeTabindex);
            }, { once: true });
        }
    }
    function getSafeAreaInsetTopPx() {
        try {
            const raw = getComputedStyle(document.documentElement).getPropertyValue("env(safe-area-inset-top)");
            const n = parseFloat(raw || "0");
            return Number.isFinite(n) ? Math.ceil(n) : 0;
        }
        catch (_a) {
            return 0;
        }
    }
    /** Pixels of opaque UI at the top of the viewport (CDP header is often position:fixed when affixed). */
    function getCdpTopChromeHeight() {
        const header = document.querySelector(".body-content > .header");
        if (!header) {
            return 0;
        }
        const rect = header.getBoundingClientRect();
        const h = Math.ceil(rect.height);
        return Math.max(h, $(".body-content > .header").outerHeight(true) || 0);
    }
    function normalizeTabHref(href) {
        const idx = href.indexOf("#");
        return idx >= 0 ? href.substring(idx) : href;
    }
    const guestCardMobileLockStyleId = "ils-guest-card-mobile-dim-lock-v2";
    /**
     * Injected stylesheet wins over load order / stale Regional-Sites Css bundles.
     * Same numbers as cdp-form.less (@cdp-guest-inner-h / @cdp-guest-nav-fixed-h).
     */
    function ensureGuestCardMobileLockStyleInjected() {
        if (document.getElementById(guestCardMobileLockStyleId)) {
            return;
        }
        const stepBodyPx = guestCardInnerMinHeightPx - guestCardNavReservedPx;
        const style = document.createElement("style");
        style.id = guestCardMobileLockStyleId;
        const guestInnerFormSelector = "#ask-question > .contact-form.cdp-guest-card-shell > .c-contact-form";
        style.textContent =
            "@media (max-width: 991px) {" +
                `${guestInnerFormSelector}{` +
                `height:${guestCardInnerMinHeightPx}px!important;` +
                `min-height:${guestCardInnerMinHeightPx}px!important;` +
                `max-height:${guestCardInnerMinHeightPx}px!important;` +
                "box-sizing:border-box!important;display:flex!important;flex-direction:column!important;overflow:hidden!important;" +
                "}" +
                `${guestInnerFormSelector} > .c-guest-card-step{` +
                "flex-grow:0!important;flex-shrink:0!important;" +
                `flex-basis:${stepBodyPx}px!important;` +
                `height:${stepBodyPx}px!important;` +
                `min-height:${stepBodyPx}px!important;` +
                `max-height:${stepBodyPx}px!important;` +
                "overflow-y:auto!important;box-sizing:border-box!important;" +
                "}" +
                `${guestInnerFormSelector} > .c-guest-card-navigation{` +
                "flex-grow:0!important;flex-shrink:0!important;" +
                `flex-basis:${guestCardNavReservedPx}px!important;` +
                `height:${guestCardNavReservedPx}px!important;` +
                `min-height:${guestCardNavReservedPx}px!important;` +
                `max-height:${guestCardNavReservedPx}px!important;` +
                "overflow-y:auto!important;box-sizing:border-box!important;" +
                "}" +
                "}";
        document.head.appendChild(style);
    }
    function clearGuestContactFormShellLayout() {
        const shell = document.querySelector(cdpGuestCardShellSelector);
        if (!shell) {
            return;
        }
        shell.style.removeProperty("max-height");
        shell.style.removeProperty("min-height");
        shell.style.removeProperty("height");
        const innerForm = shell.querySelector(":scope > .c-contact-form");
        if (innerForm) {
            innerForm.style.removeProperty("height");
            innerForm.style.removeProperty("min-height");
            innerForm.style.removeProperty("max-height");
            const stepEl = innerForm.querySelector(":scope > .c-guest-card-step");
            if (stepEl) {
                stepEl.style.removeProperty("height");
                stepEl.style.removeProperty("min-height");
                stepEl.style.removeProperty("max-height");
                stepEl.style.removeProperty("flex");
            }
            const navEl = innerForm.querySelector(":scope > .c-guest-card-navigation");
            if (navEl) {
                navEl.style.removeProperty("height");
                navEl.style.removeProperty("min-height");
                navEl.style.removeProperty("max-height");
                navEl.style.removeProperty("overflow-y");
            }
        }
    }
    /** Lock inner column + fixed nav slab + fixed step body so Schedule-a-tour (and all types) do not change height by step. */
    function applyGuestCardMobileStepNavLocks(shell) {
        if (globalThis.breakpoint() !== "mobile") {
            return;
        }
        ensureGuestCardMobileLockStyleInjected();
        const innerForm = shell.querySelector(":scope > .c-contact-form");
        if (!innerForm) {
            return;
        }
        const innerPx = `${guestCardInnerMinHeightPx}px`;
        innerForm.style.setProperty("height", innerPx, "important");
        innerForm.style.setProperty("min-height", innerPx, "important");
        innerForm.style.setProperty("max-height", innerPx, "important");
        const navPx = `${guestCardNavReservedPx}px`;
        const navEl = innerForm.querySelector(":scope > .c-guest-card-navigation");
        if (navEl) {
            navEl.style.setProperty("flex-shrink", "0", "important");
            navEl.style.setProperty("flex-grow", "0", "important");
            navEl.style.setProperty("flex-basis", navPx, "important");
            navEl.style.setProperty("min-height", navPx, "important");
            navEl.style.setProperty("max-height", navPx, "important");
            navEl.style.setProperty("height", navPx, "important");
            navEl.style.setProperty("overflow-y", "auto", "important");
            navEl.style.setProperty("box-sizing", "border-box", "important");
        }
        const stepBodyPx = guestCardInnerMinHeightPx - guestCardNavReservedPx;
        const stepPx = `${stepBodyPx}px`;
        const stepEl = innerForm.querySelector(":scope > .c-guest-card-step");
        if (stepEl) {
            stepEl.style.setProperty("flex-shrink", "0", "important");
            stepEl.style.setProperty("flex-grow", "0", "important");
            stepEl.style.setProperty("flex-basis", stepPx, "important");
            stepEl.style.setProperty("min-height", stepPx, "important");
            stepEl.style.setProperty("max-height", stepPx, "important");
            stepEl.style.setProperty("height", stepPx, "important");
            stepEl.style.setProperty("overflow-y", "auto", "important");
            stepEl.style.setProperty("box-sizing", "border-box", "important");
        }
    }
    /** Min outer .contact-form height so inner .c-contact-form can stay 627px under h2 (matches cdp-form.less). */
    function getGuestCardShellMinHeightPx(shell) {
        const h2El = shell.querySelector(":scope > h2.line-after");
        let h2HeightPx = 0;
        if (h2El) {
            const cs = window.getComputedStyle(h2El);
            if (cs.display !== "none" && cs.visibility !== "hidden") {
                h2HeightPx = Math.ceil(h2El.getBoundingClientRect().height);
            }
        }
        return h2HeightPx + guestCardInnerMinHeightPx;
    }
    /** Matches jQuery breakpoint(): mobile is width < 992 — keeps Back/Next row pinned in the guest card. */
    function syncGuestContactFormShellHeight(forceRemeasure) {
        if (globalThis.breakpoint() !== "mobile") {
            return;
        }
        if (ils.viewModel.SubmittedContactTypes().length > 0) {
            clearGuestContactFormShellLayout();
            return;
        }
        const panel = document.getElementById("ask-question");
        if (!panel || !$(panel).is(":visible")) {
            clearGuestContactFormShellLayout();
            return;
        }
        const shell = panel.querySelector(":scope > .contact-form.cdp-guest-card-shell");
        if (!shell || !$(shell).is(":visible") || !shell.querySelector(".c-contact-form")) {
            clearGuestContactFormShellLayout();
            return;
        }
        // Run before early return: step changes do not call force remeasure, but flex would otherwise give
        // .c-guest-card-step a different height whenever the nav block's content height changes.
        applyGuestCardMobileStepNavLocks(shell);
        const existingH = parseFloat(shell.style.height || "0");
        const mustShellPx = getGuestCardShellMinHeightPx(shell);
        // Do not keep rewriting inline height on every debounced callback — that is what moves Back/Next.
        // Still remeasure if the shell is too short to fit h2 + 627px inner (stale ~551px from older builds).
        if (!forceRemeasure && existingH > 50 && existingH >= mustShellPx - 1) {
            return;
        }
        const vv = window.visualViewport;
        const vh = vv && vv.height > 0 ? vv.height : window.innerHeight;
        const rect = shell.getBoundingClientRect();
        // Scroll alignment uses getCdpTopChromeHeight; shell height must agree. When .header is affix/fixed,
        // the top of .contact-form can sit under the chrome (small rect.top) while h2 is still partly covered —
        // measuring the band from max(shell top, chrome bottom) matches the visible strip above .contact-bottom.
        const chromeTop = getCdpTopChromeHeight() + getSafeAreaInsetTopPx();
        const topInView = Math.max(rect.top, chromeTop);
        const bar = document.querySelector(".contact-bottom");
        let bottomReserve = 72;
        if (bar) {
            const br = bar.getBoundingClientRect();
            // Space reserved above .contact-bottom (email / phone). Keep a small breathing gap only —
            // user asked ~10px tighter than the old +10 fudge.
            bottomReserve = Math.max(52, vh - br.top);
        }
        // Smaller slack pulls the guest-card shell (and .c-guest-card-step-nav) closer to .contact-options.
        const slack = 6;
        // Use the real band between shell top and footer — never force a large min (e.g. 400px) above that.
        // On iPhone SE, max(400, calculated) made the shell taller than the viewport band and clipped the
        // scroll area so fields (e.g. phone) disappeared between the label and progress bar.
        const rawBand = Math.floor(vh - topInView - bottomReserve - slack);
        const minShellPx = getGuestCardShellMinHeightPx(shell);
        const bandPx = Math.max(minShellPx, Math.max(180, rawBand));
        // height + max-height: KO only shows one step (display:none on others). max-height alone still
        // lets the flex column shrink to that step's content — nav jumps. A definite height reserves the
        // same vertical band as the heaviest step (comments): shorter steps scroll inside empty space.
        shell.style.height = `${bandPx}px`;
        shell.style.maxHeight = `${bandPx}px`;
        applyGuestCardMobileStepNavLocks(shell);
    }
    function scheduleSyncGuestContactFormShellHeight(forceRemeasure) {
        if (globalThis.breakpoint() !== "mobile") {
            return;
        }
        if (guestFormLayoutSyncTimer) {
            window.clearTimeout(guestFormLayoutSyncTimer);
        }
        const force = !!forceRemeasure;
        guestFormLayoutSyncTimer = window.setTimeout(() => {
            guestFormLayoutSyncTimer = undefined;
            syncGuestContactFormShellHeight(force);
        }, 120);
    }
    /** Scroll the visible guest-card wrapper into view when opening the Ask tab (mobile + narrow desktop). */
    function scrollContactFormIntoView(onComplete) {
        const run = () => {
            const $visible = $("#ask-question .contact-form").filter(":visible").first();
            const el = $visible[0];
            if (!el) {
                onComplete === null || onComplete === void 0 ? void 0 : onComplete();
                return;
            }
            const useSmooth = globalThis.breakpoint() === "mobile";
            const $title = $visible.children("h2.line-after").filter(":visible").first();
            const $scrollRef = $title.length ? $title : $visible;
            const formTop = $scrollRef.offset().top;
            const buffer = getCdpTopChromeHeight() + getSafeAreaInsetTopPx() + 16;
            const scrollTarget = Math.max(0, formTop - buffer);
            const alignTitleToChrome = (behavior) => {
                var _a;
                const ref = (_a = $visible.children("h2.line-after").filter(":visible").first()[0]) !== null && _a !== void 0 ? _a : el;
                const top = ref.getBoundingClientRect().top;
                const need = getCdpTopChromeHeight() + getSafeAreaInsetTopPx() + 10;
                const delta = top - need;
                if (Math.abs(delta) > 2) {
                    window.scrollBy({ top: delta, left: 0, behavior });
                }
            };
            $([document.documentElement, document.body]).stop(true).animate({ scrollTop: scrollTarget }, useSmooth ? 320 : 0, () => {
                alignTitleToChrome(useSmooth ? "smooth" : "auto");
                window.requestAnimationFrame(() => {
                    alignTitleToChrome("auto");
                    window.requestAnimationFrame(() => {
                        alignTitleToChrome("auto");
                        focusContactFormLandmark(el);
                        scheduleSyncGuestContactFormShellHeight();
                        onComplete === null || onComplete === void 0 ? void 0 : onComplete();
                    });
                });
            });
        };
        if (globalThis.breakpoint() === "mobile") {
            window.setTimeout(run, 100);
        }
        else {
            run();
        }
    }
    function scrollToActiveTab(hrefHashId) {
        isAutoScrolling = true;
        const tabHash = normalizeTabHref(hrefHashId);
        if (tabHash === "#ask-question") {
            scrollContactFormIntoView(() => {
                scheduleSyncGuestContactFormShellHeight();
                isAutoScrolling = false;
            });
            return;
        }
        $([document.documentElement, document.body]).animate({
            scrollTop: $(tabHash).offset().top - 100
        }, 0, function () {
            isAutoScrolling = false;
        });
    }
    ;
    function getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) {
                return pair[1];
            }
        }
        return (false);
    }
    ;
    function setTabFromScrollPosition() {
        let targetHref = ils.activeTabHash;
        // This iterates through each tab section (the viewable area of the tab) and sets the tab to active or inactive. The last one we process here
        // is the one that will be the active tab
        $('.cdp-section').each(function () {
            if ($(window).scrollTop() >= ($(this).offset().top - 300)) {
                var id = $(this).attr('id');
                targetHref = $(".nav li.cdp-tab a[href='#" + id + "']").attr("href");
                $(".nav li.cdp-tab").toggleClass("active", false);
                $(".nav li.cdp-tab a[href='#" + id + "']").parent("li").toggleClass("active", true);
            }
        });
        // Take action on the tab we ended up on
        if (targetHref !== ils.activeTabHash) {
            takeActionOnTab(targetHref);
            ils.activeTabHash = targetHref;
        }
    }
    ;
    function navigateToCheckAvailability() {
        ils.viewModel.ActiveTabText("Check Availability");
        ils.viewModel.ProspectForm.ContactTypeID(3);
        switchTabs(null, "#ask-question");
    }
    function navigateToScheduleTour() {
        ils.viewModel.ActiveTabText("Schedule a Tour");
        ils.viewModel.ProspectForm.ContactTypeID(2);
        switchTabs(null, "#ask-question");
        // Make a call to the API to sync latest tour times
        fetch(`${globalThis.baseUrl}mvc-api/showcase/sync-available-tour-time-slots?showcaseItemID=${globalThis.showcaseItemID}`, {
            method: 'GET'
        })
            .then(response => response.text())
            .then(content => {
            console.log(content);
        })
            .catch(error => console.warn(error));
    }
    function navigateToApplyNow() {
        ils.viewModel.ActiveTabText("Apply Now");
        ils.viewModel.ProspectForm.ContactTypeID(5);
        switchTabs(null, "#ask-question");
    }
    function takeActionOnTab(targetHref) {
        if (!targetHref) {
            return;
        }
        const text = !ils.viewModel.ActiveTabText() ? $(`.cdp-menu a[href='${targetHref}']`).text().trim() : ils.viewModel.ActiveTabText();
        const tabClickData = {
            communityId: ils.communityId,
            communityName: ils.communityName,
            tabName: text,
            communityUrl: ils.communityUrl
        };
        ils.trackCDPTabClickEvent(tabClickData);
        TrackTimeForNewTab(text);
        const tabHashForAction = normalizeTabHref(targetHref || "");
        ils.viewModel.ProspectForm.StepManager.TurnOnStepTimeTracking(tabHashForAction === "#ask-question");
        if (tabHashForAction === "#ask-question") {
            ils.trackFormView(ils.viewModel.ProspectForm.StepManager.FormType(), ils.communityName, ils.communityId);
            scheduleSyncGuestContactFormShellHeight();
        }
        else if (targetHref === "#deals") {
            ils.trackFormView("Featured Specials", ils.communityName, ils.communityId);
        }
        // We're resetting this to an null because this only gets set when the text does not match the tab (i.e. Get More Information vs Schedule a Tour)
        ils.viewModel.ActiveTabText(null);
        // Take action based on the tab we're on
        if (targetHref == "#floorplans") {
            if (!ils.floorPlanLoaded) {
                BindPriceSlider();
                BindBedroomSlider();
                ils.floorPlanLoaded = true;
            }
        }
        else if (targetHref == "#neighborhood") {
            if (!ils.googleStaticNeighborhoodMapLoaded) {
                maps.initializeStaticNeighborhoodMap();
                if ($.inArray(globalThis.neighborhoodAdTypeID, ils.trackedAdViews) == -1) {
                    TrackAdView(globalThis.neighborhoodAdTypeID);
                    ils.trackedAdViews.push(globalThis.neighborhoodAdTypeID);
                }
            }
            else {
                if ($.inArray(globalThis.neighborhoodAdTypeID, ils.trackedAdViews) == -1) {
                    TrackAdView(globalThis.neighborhoodAdTypeID);
                    ils.trackedAdViews.push(globalThis.neighborhoodAdTypeID);
                }
            }
        }
        else if (targetHref == "#amenities" && !hasRoles) {
            if (ils.trackedImpressions.length == 0) {
                $(".attribute-list [data-impression]").each(function () {
                    var impressionID = $(this).data("impression");
                    ils.trackedImpressions.push(impressionID);
                });
                if (ils.trackedImpressions.length > 0)
                    $.ajax({
                        type: 'POST',
                        url: globalThis.baseUrl + "TftServices/Showcase/ShowcaseWebMethods.asmx/TrackAttributeListingImpression",
                        data: '{ showcaseAttributeValueID: ' + JSON.stringify(ils.trackedImpressions) + '}',
                        contentType: 'application/json; charset=utf-8',
                        dataType: 'json'
                    });
            }
            if ($.inArray(globalThis.amenityAdTypeID, ils.trackedAdViews) == -1) {
                TrackAdView(globalThis.amenityAdTypeID);
                ils.trackedAdViews.push(globalThis.amenityAdTypeID);
            }
        }
        else if (targetHref == "#hours-directions") {
            if (!ils.googleStaticCommunityMapLoaded) {
                maps.initializeStaticMap();
            }
        }
        else if (targetHref == "#facebook-feed") {
            const clickData = {
                communityId: ils.communityId,
                communityName: ils.communityName,
                communityUrl: ils.communityUrl,
                clickTypeId: ClickType.FacebookFeed
            };
            TrackClickData(clickData);
        }
        else if (targetHref == "#news") {
            const clickData = {
                communityId: ils.communityId,
                communityName: ils.communityName,
                communityUrl: ils.communityUrl,
                clickTypeId: ClickType.LocalNews
            };
            TrackClickData(clickData);
        }
    }
    function switchTabs(e, target) {
        var _a;
        let targetHref = target !== null && target !== void 0 ? target : (_a = e.target) === null || _a === void 0 ? void 0 : _a.href;
        if (!targetHref) {
            let element = e.target;
            while (element && !element.hasAttribute('href') && !element.tagName.match(/body/i)) {
                element = element.parentElement;
            }
            const parentHref = element === null || element === void 0 ? void 0 : element.getAttribute('href');
            targetHref = parentHref !== null && parentHref !== void 0 ? parentHref : '#overview';
        }
        const tabHash = normalizeTabHref(String(targetHref));
        if (tabHash !== "#ask-question") {
            clearGuestContactFormShellLayout();
        }
        scrollToActiveTab(targetHref);
        // Do not sync shell height immediately — scrollToActiveTab animates ~320ms; early sync used shell.getBoundingClientRect()
        // while the form was still below the fold and set a tiny max-height, clipping the step. Callback + delayed pass only.
        if (tabHash === "#ask-question") {
            window.setTimeout(() => scheduleSyncGuestContactFormShellHeight(), 420);
            window.setTimeout(() => scheduleSyncGuestContactFormShellHeight(), 700);
        }
        if (globalThis.breakpoint() == "mobile")
            document.querySelectorAll('.cdp').forEach((el) => el.classList.remove('side-nav-open'));
    }
    function PhotoIframeClick(e) {
        const targetElem = $(e.target);
        let listElem = targetElem.closest('li');
        const isFloorPlan = listElem && listElem.hasClass("floorplan");
        let element = targetElem;
        if (!targetElem.is('[href]'))
            element = targetElem.closest('[href]'); //catch bubbles
        const photoModal = $("#photo-modal");
        const modalExtra = photoModal.find('.modal-extra');
        const modalNav = modalExtra.find('.modal-navigation');
        const galleryInfo = modalExtra.find(".gallery-info");
        const gallery = element.prop("rel") != '';
        const hasVirtualTour = element.data('tour');
        if (isFloorPlan) {
        }
        SetModalBodyContent(element);
        modalNav.toggle(gallery);
        galleryInfo.toggle(gallery);
        if (gallery) {
            if (element.hasClass("clone"))
                element = $(`[rel='${element.prop("rel")}'][href='${element.attr("href")}']:not(.clone)`);
            var galleryIndex = element.data("id");
            var totalInGallery = $(`[rel='${element.prop("rel")}']:not(.clone)`).length;
            if (element.prop("rel").indexOf("floorplan") == 0) {
                galleryIndex = 1;
                totalInGallery = $(".media-items [data-additional-galleries*=" + element.prop("rel").replace("floorplan-", "") + "]").length + 1;
            }
            photoModal.data("gallery-number", galleryIndex);
            photoModal.data("gallery-name", element.prop("rel"));
            galleryInfo.find(".current").html(galleryIndex);
            galleryInfo.find(".total").html(totalInGallery.toString());
            if (hasVirtualTour) {
                navigatePhotoModal(e, true);
            }
        }
        parent.$("#iframe-modal > .modal-dialog > .modal-content > .modal-header > .close").hide();
        photoModal.modal();
        photoModal.on('hide.bs.modal', function (e) {
            photoModal.removeClass("photo-modal--portrait");
            parent.$("#iframe-modal > .modal-dialog > .modal-content > .modal-header > .close").show();
        });
        return false;
    }
    function navigatePhotoModal(e, goToVirtualTour = false) {
        var photoModal = $("#photo-modal");
        var galleryInfo = photoModal.find(".modal-extra .gallery-info");
        var galleryName = photoModal.data("gallery-name");
        var nextIndex = photoModal.data("gallery-number");
        if ($(this).hasClass('prev'))
            nextIndex--;
        else
            nextIndex++;
        var totalItems = parseInt(galleryInfo.find(".total").text());
        if (nextIndex > totalItems)
            nextIndex = 1;
        else if (nextIndex <= 0)
            nextIndex = totalItems;
        galleryInfo.find(".current").html(nextIndex);
        photoModal.data("gallery-number", nextIndex);
        var element = galleryName.indexOf("floorplan") == -1
            ? $("a[rel='" + galleryName + "'][data-id='" + nextIndex + "']") : nextIndex == 1 ? $("a[rel=" + galleryName + "]")
            : goToVirtualTour
                ? $(`.media-items [data-floorplan-virtual-tour*=${galleryName.replace("floorplan-", "")}]:eq(${nextIndex - 2})`)
                : $(`.media-items [data-additional-galleries*=${galleryName.replace("floorplan-", "")}]:eq(${nextIndex - 2})`);
        SetModalBodyContent(element);
    }
    function SetModalBodyContent(element) {
        var photoModal = $("#photo-modal");
        var modalBody = photoModal.find('.modal-body');
        var modalExtra = photoModal.find('.modal-extra');
        const isPortrait = element.data("vertical") === true || element.hasClass("video-thumbnail--portrait");
        photoModal.toggleClass("photo-modal--portrait", !!isPortrait);
        if (element.attr("href") && element.attr("href").indexOf('#') == 0) {
            modalBody.html($(element.attr("href")).html());
            // This is how we track impressions on a 3Dx Virtual Tour. We can't track a click event on an iframe, so 
            // this is the next best thing.
            const displayElement = $($(element.attr("href")).html());
            if (displayElement.hasClass('virtual-tour-iframe')) {
                const vtUrl = displayElement.attr('src');
                Track3DxVirtualTourViewedEvent(vtUrl, ils.communityId, ils.communityName);
            }
        }
        else
            modalBody.html('<img alt="' + element.prop("title") + '" class="img-responsive" src="' + element.prop("href") + '" />');
        modalExtra.find(".title > span").html(element.prop("title"));
    }
    function BindBedroomSlider() {
        var sliderElement = $("#uxBedroomRangeSlider");
        var values = ils.viewModel.FloorPlanBedrooms();
        var value1 = globalThis.bedroomMin && globalThis.bedroomMin > values[0] ? globalThis.bedroomMin : values[0];
        var value2 = globalThis.bedroomMax && globalThis.bedroomMax < values[values.length - 1] ? globalThis.bedroomMax : values[values.length - 1];
        sliderElement.slider({
            range: true,
            min: values[0],
            max: values[values.length - 1],
            values: [value1, value2],
            create: function (event, ui) {
                if (sliderElement.find(".handle-text").length == 0)
                    sliderElement.find(".ui-slider-handle").append('<span class="handle-text"></span>');
                sliderElement.find(".handle-text:first").html(FormatBedroomText(value1));
                sliderElement.find(".handle-text:last").html(FormatBedroomText(value2));
                sliderElement.find(".ui-slider-handle:last").addClass("reverse");
                UnstackSliderLabels(sliderElement.find(".ui-slider-handle:" + (value2 == values[0] ? "last" : "first")), value1, value2);
                bedroomSliderUpdateFilter(sliderElement);
            },
            slide: function (event, ui) {
                var handle = $(ui.handle);
                handle.find(".handle-text").html(FormatBedroomText(ui.value));
                UnstackSliderLabels(handle, ui.values[0], ui.values[1]);
            },
            stop: function (event, ui) {
                bedroomSliderUpdateFilter(sliderElement);
            }
        });
    }
    function priceSliderUpdateFilter(sliderElement) {
        var minValue = sliderElement.slider("values", 0);
        var maxValue = sliderElement.slider("values", 1);
        ils.viewModel.PriceMin(minValue);
        ils.viewModel.PriceMax(maxValue);
    }
    function bedroomSliderUpdateFilter(sliderElement) {
        var minValue = sliderElement.slider("values", 0);
        var maxValue = sliderElement.slider("values", 1);
        if (minValue == "Studio")
            minValue = 0;
        if (maxValue == "Studio")
            maxValue = 0;
        ils.viewModel.BedroomMin(minValue);
        ils.viewModel.BedroomMax(maxValue);
    }
    function UnstackSliderLabels(handle, value1, value2) {
        var unstackTimeout = setTimeout(function () {
            var handleText = handle.find(".handle-text");
            var rightHandleLabel = handle.parent().find(".ui-slider-handle:last .handle-text");
            if (value1 == value2) {
                handle.addClass("on-top");
                handleText.html("Only");
            }
            else {
                handle.removeClass("on-top");
            }
            var leftHandleLabel = handle.parent().find(".ui-slider-handle:first .handle-text");
            leftHandleLabel.css("margin-left", "0px");
            rightHandleLabel.css("margin-left", "0px");
            var leftHandleEnd = leftHandleLabel.offset().left + leftHandleLabel.outerWidth(true);
            var rightHandleStart = rightHandleLabel.offset().left;
            var offset = rightHandleStart - leftHandleEnd;
            if (offset < 0) {
                if (handle.hasClass("reverse"))
                    rightHandleLabel.css("margin-left", offset + "px");
                else
                    leftHandleLabel.css("margin-left", offset + "px");
            }
            clearTimeout(unstackTimeout);
        }, 5);
    }
    function FormatBedroomText(numBeds) {
        return numBeds == 0 ? "Studio" : numBeds + "BR";
    }
    document.addEventListener("DOMContentLoaded", function () {
        ////////////////////////////
        // Setup analytics tracking for 3Dx Virtual Tours 
        ////////////////////////////
        const virtualTourFrames = document.getElementsByClassName("virtual-tour-iframe");
        if (virtualTourFrames.length > 0) {
            window.addEventListener('blur', () => {
                var isVirtualTour = document.activeElement.classList.contains('virtual-tour-iframe');
                if (isVirtualTour) {
                    try {
                        const activatedVirtualTour = document.activeElement;
                        const src = activatedVirtualTour.src;
                        console.log("Sending 'Explored' event for 3Dx Virtual Tours");
                        Track3DxVirtualTourViewedEvent(src, ils.communityId, ils.communityName);
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
            });
        }
        // Time tracking for tabs
        TrackTimeForNewTab($(".cdp-menu .active a").text());
        ko.applyBindings(ils.viewModel);
        ils.initMetaLeadCdpOverlayFromQuery();
        if (globalThis.breakpoint() === "mobile") {
            ensureGuestCardMobileLockStyleInjected();
        }
        if ($("#floorplans").length > 0)
            $.ajax({
                type: 'POST',
                url: globalThis.baseUrl + "TftServices/Showcase/ShowcaseWebMethods.asmx/LoadFloorPlans",
                data: `{ showcaseItemID: "${globalThis.showcaseItemID}"}`,
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                success: function (data) {
                    var tempFloorPlans = [];
                    for (let i = 0; i < data.d.length; i++) {
                        let sourcePlan = {};
                        Object.assign(sourcePlan, data.d[i]);
                        sourcePlan.VirtualTourUrl = data.d[i].VirtualTourMedia ? data.d[i].VirtualTourMedia.URL : null;
                        let tempPlan = new ils.FloorPlanInfo(sourcePlan);
                        tempFloorPlans.push(tempPlan);
                    }
                    ils.viewModel.FloorPlans(tempFloorPlans);
                    $(".floorplan .add-tooltip").tooltip();
                    $(".add-tooltip-with-info").each(function () {
                        $(this).tooltip({ html: true, title: $(this).html() });
                        $(this).html('&nbsp;<i class="fa fa fa-info-circle"></i>');
                        $(this).removeClass("add-tooltip").addClass("tooltip-added");
                    });
                    //$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                    //    switchTabs(e);
                    //});
                    $('[data-contact="check-availability"]').on("click", function (e) {
                        $(e.target).attr("href", "#ask-question");
                        ils.viewModel.ActiveTabText("Check Availability");
                        ils.viewModel.ProspectForm.ContactTypeID(3);
                    });
                    allFloorPlansLoaded = true;
                    FixHeightsAfterImagesLoaded($("#floorplans"));
                    BindPriceSlider();
                    BindBedroomSlider();
                    // This shows/hides elements that are being used for A/B tests on Google Optimize. The `.g-ab-test` is a custom class for targeting elements
                    var timeout = setTimeout(function () {
                        $('.g-ab-test').toggleClass("hide", !globalThis.googleOptimizeIsLoaded);
                        clearTimeout(timeout);
                    }, 2000);
                }
            });
        window.addEventListener('focus', function () {
            var _a;
            if (!windowInactiveTime)
                return;
            try {
                const timeInactive = Math.abs((new Date() - windowInactiveTime));
                (_a = currentTiming.startTime) === null || _a === void 0 ? void 0 : _a.setMilliseconds(currentTiming.startTime.getMilliseconds() + timeInactive);
            }
            catch (error) {
                console.error(error);
            }
        });
        window.addEventListener('blur', function () {
            windowInactiveTime = new Date();
        });
        if (parent.$("#iframe-modal").length > 0) {
            $("body").addClass("in-modal");
            parent.$("#iframe-modal").off('hide.bs.modal').off('hidden.bs.modal').on('hide.bs.modal', function (e) {
                SendTimings();
                ils.viewModel.ProspectForm.StepManager.SendFormCompletionMetrics(ils.viewModel.ProspectForm.SubmitHasBeenClicked());
            }).on('hidden.bs.modal', function (e) {
                $(e.target).find(".modal-body").html("");
            });
            parent.$(window).blur(function () {
                windowInactiveTime = new Date();
            });
        }
        else {
            window.addEventListener('beforeunload', SafeSendTimings);
            // pagehide is the modern, reliable replacement for beforeunload and fires on bfcache
            // transitions and tab discard on mobile, where beforeunload often does not.
            window.addEventListener('pagehide', SafeSendTimings);
            // visibilitychange to "hidden" catches the user switching apps / tabs on mobile, which
            // is frequently the only signal we get before the tab is killed.
            document.addEventListener('visibilitychange', function () {
                if (document.visibilityState === 'hidden') {
                    SafeSendTimings();
                }
            });
        }
        if (!globalThis.hasRoles) {
            ils.trackCommunityViewEvent({ communityId: ils.communityId, communityName: ils.communityName, communityUrl: ils.communityUrl });
        }
        if (globalThis.abTestOverview != null) {
            TrackABView(`${globalThis.abOverviewName}View`, globalThis.abTestOverview ? "main" : "alternate", ils.communityId, ils.communityName);
        }
        // Track_FormView when the form type changes while #ask-question is already the active tab.
        // takeActionOnTab only fires when the tab itself changes, so switching form types within the
        // same tab (e.g. Get More Info → Schedule Tour) would otherwise go untracked.
        ils.viewModel.ProspectForm.StepManager.FormType.subscribe((formType) => {
            if (ils.activeTabHash !== "#ask-question") {
                return;
            }
            ils.trackFormView(formType, ils.communityName, ils.communityId);
        });
        // Track form start and (for Get More Info only) step 1 navigation on first focus of the name input.
        // Track_FormStart fires once per form type per page load — a Set guards against re-firing if the user
        // clicks away and back, while still allowing a fresh event if they switch form types.
        // Track_StepFormNavigation for step 1 is only needed for Get More Info because all other form types
        // already trigger it via the ContactTypeID -> FormType -> setFormState chain.
        const formStartTracked = new Set();
        $(document).on("focus", "#guestName", () => {
            const stepManager = ils.viewModel.ProspectForm.StepManager;
            const formType = stepManager.FormType();
            if (formStartTracked.has(formType)) {
                return;
            }
            formStartTracked.add(formType);
            ils.trackFormStart(formType, stepManager.CommunityName(), stepManager.CommunityId());
            if (formType === ils.showcase.FormType.GetMoreInfo) {
                const activeIndex = stepManager.ActiveViews().findIndex(v => v.StepName() === stepManager.ActiveView());
                ils.trackStepFormNavigation(formType, stepManager.ActiveView(), activeIndex + 1, stepManager.ActiveViews().length, stepManager.CommunityName(), stepManager.CommunityId());
            }
        });
        $(".header-action a.href-action").on('click', function () {
            const text = $(this).text();
            // If they click the phone number in the upper right of the CDP
            if (text && text.startsWith('(')) {
                TrackClickData({ clickTypeId: 9, communityId: ils.communityId, communityName: ils.communityName, communityUrl: ils.communityUrl });
            }
        });
        function OnResize() {
            document.querySelector(".header").style.width = `${document.querySelector(".body-content").offsetWidth}px`;
        }
        window.addEventListener('resize', function () {
            OnResize();
            if (globalThis.breakpoint() === "mobile") {
                scheduleSyncGuestContactFormShellHeight(true);
            }
            else {
                clearGuestContactFormShellLayout();
            }
        });
        if (window.visualViewport) {
            window.visualViewport.addEventListener("resize", () => {
                if (globalThis.breakpoint() === "mobile") {
                    scheduleSyncGuestContactFormShellHeight(true);
                }
            });
        }
        OnResize();
        if ($(".navigation .navbar").length > 0) {
            $(".header").affix({
                offset: { top: Math.max($(".navigation").outerHeight(true), 1) }
            });
            $($(window).width() < 985 ? "#cdp-menu-collapse" : ".cdp-menu").affix({
                offset: {
                    top: Math.max($(".navigation").outerHeight(true), 1),
                    bottom: function () {
                        if ($("footer").length > 0)
                            return (this.bottom = $("footer").outerHeight(true) + parseInt($(".cdp").css("padding-bottom")));
                    }
                }
            }).on("affix.bs.affix", function () {
                if ($(window).scrollTop() == 0)
                    return false;
            });
        }
        else {
            $(".header," + ($(window).width() < 985 ? "#cdp-menu-collapse" : ".cdp-menu")).addClass("affix");
            $(".body-content .tab-content").css("padding-top", $(".header").outerHeight() + 10);
        }
        // Affix toggles fixed header + layout — guest-card shell sync is mobile-only.
        $(".body-content > .header").on("affixed.bs.affix affixed-top.bs.affix", () => {
            if (globalThis.breakpoint() === "mobile") {
                scheduleSyncGuestContactFormShellHeight(true);
            }
        });
        if (globalThis.breakpoint() == "mobile") {
            $(".header .navbar-toggle").on('click', function () {
                $(".cdp").toggleClass("side-nav-open");
                return false;
            });
        }
        const tabLinks = document.querySelectorAll('a[data-toggle="tab"]');
        tabLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                const targetElem = e.target;
                const target = targetElem.getAttribute("href");
                switchTabs(e, target);
            });
        });
        const tabClickLinks = document.querySelectorAll('a[data-toggle="tab-click"]');
        tabClickLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                const targetElem = e.target;
                const target = targetElem.getAttribute("href");
                switchTabs(e, target);
                ils.viewModel.ProspectForm.ContactTypeID(1);
            });
        });
        // Mobile-only: shell sync after Ask is shown (desktop unchanged from pre–guest-card work).
        $(document).on("shown.bs.tab", 'a[data-toggle="tab"]', function () {
            const href = this.getAttribute("href");
            if (!href || normalizeTabHref(href) !== "#ask-question") {
                return;
            }
            if (globalThis.breakpoint() !== "mobile") {
                return;
            }
            window.requestAnimationFrame(() => {
                syncGuestContactFormShellHeight(true);
                scheduleSyncGuestContactFormShellHeight(true);
            });
            window.setTimeout(() => syncGuestContactFormShellHeight(true), 60);
            window.setTimeout(() => syncGuestContactFormShellHeight(true), 380);
        });
        const contactMenu = document.querySelector("#contact-menu a");
        if (contactMenu) {
            contactMenu.addEventListener('click', function () {
                const contactOptions = document.querySelectorAll(".contact-options a");
                if (contactOptions.length > 0) {
                    contactOptions[0].click();
                }
            });
        }
        if (globalThis.breakpoint() == "mobile") {
            const cdpMenuLinks = document.querySelectorAll(".header .cdp-menu a");
            cdpMenuLinks.forEach(link => {
                link.addEventListener('click', () => {
                    document.querySelector(".navbar-toggle").click();
                });
            });
        }
        $(".media-items a[rel], .media-item").on('click', PhotoIframeClick);
        $(document).on('click', '.floorplan .photo', PhotoIframeClick);
        $("#photo-modal .modal-navigation a").on("click", navigatePhotoModal);
        if ($(".media-items ul li").length <= 5 && globalThis.breakpoint() != "mobile") {
            let totalWidth = 0;
            $(".media-items ul li").each(function () {
                totalWidth += $(this).outerWidth(true);
            });
            $(".media-items ul").css({ margin: "0 auto", width: totalWidth });
        }
        if (globalThis.breakpoint() == "mobile") {
            $(".map-address").each(function () {
                var mapLink = '<a target="_blank" href="http://maps.google.com/?q=' + $(this).text().replace("<br>", " ") + '">' + $(this).html() + '</a>';
                $(this).html(mapLink);
            });
        }
        $(".resend").on('click', function () {
            $(".send-container").show();
            $(".send-complete").hide();
        });
        $("#uxSwitchDirection").on('click', function () {
            var directionAValue = $("#uxDirectionsAptAddress").val();
            var directionAPlaceHolder = $("#uxDirectionsAptAddress").attr("placeholder");
            var directionBValue = $("#uxDirectionsBAddress").val();
            var directionBPlaceHolder = $("#uxDirectionsBAddress").attr("placeholder");
            $("#uxDirectionsAptAddress").val(directionBValue).attr("placeholder", directionBPlaceHolder);
            $("#uxDirectionsBAddress").val(directionAValue).attr("placeholder", directionAPlaceHolder);
            return false;
        });
        $("#uxGetDirections").on('click', function () {
            var directionAValue = $("#uxDirectionsAptAddress").val();
            var directionBValue = $("#uxDirectionsBAddress").val();
            if (directionAValue == globalThis.communityName) {
                directionAValue = globalThis.residenceAddress;
            }
            if (directionBValue == globalThis.communityName) {
                directionBValue = globalThis.residenceAddress;
            }
            GetDirections(directionAValue, directionBValue);
            return false;
        });
        function GetDirections(sAddr, dAddr) {
            sAddr = sAddr.replace(/ /g, "+");
            dAddr = dAddr.replace(/ /g, "+");
            if (sAddr == '' || dAddr == '') {
                alert('You must fill in your address to get directions.');
                return;
            }
            const clickData = {
                communityId: ils.communityId,
                communityName: ils.communityName,
                communityUrl: ils.communityUrl,
                clickTypeId: ClickType.Directions
            };
            TrackClickData(clickData);
            var directionsUrl = `http://maps.google.com/maps?f=d&source=s_d&saddr=${sAddr}&daddr=${dAddr}&hl=en`;
            const keyLeadData = {
                communityId: ils.communityId,
                communityName: ils.communityName,
                communityUrl: ils.communityUrl,
                keyLeadType: ils.aptsforConstants.keyLeadTypes.directionsRequested,
                additionalData: {
                    directionsUrl: directionsUrl
                }
            };
            ils.trackKeyLead(keyLeadData);
            window.open(directionsUrl);
        }
        $(".add-tooltip").tooltip();
        if ($(".contact-form ul.floorplans li").length == 5 && globalThis.breakpoint() != "mobile") {
            $(".contact-form ul.floorplans").css({ margin: "0 auto", width: $(".contact-form ul.floorplans li").css("min-width") });
        }
        $("#selectAllFloorplans,#newSelectAllFloorPlans").on('click', function () {
            for (var i = 0; i < ils.viewModel.FloorPlans().length; i++) {
                if ($.inArray(ils.viewModel.FloorPlans()[i].FloorPlanID, ils.viewModel.ProspectForm.SelectedFloorPlans()) == -1)
                    ils.viewModel.ProspectForm.SelectedFloorPlans.push(ils.viewModel.FloorPlans()[i].FloorPlanID);
            }
        });
        $("#uxNewDateOfVisit_datetimepicker").on("dp.change", function (e) {
            ils.clearTourDateValidationMessage(ils.viewModel.ProspectForm.StepManager);
            ils.viewModel.ProspectForm.DateOfVisit(e.date);
            let dateValue = `${$("#uxNewDateOfVisit_uxDate").val()}`;
            if (!dateValue || dateValue === "undefined") {
                dateValue = "";
            }
            getHoursOpen(dateValue);
        });
        $("#uxNewTimeOfVisit").on("change", () => {
            ils.clearTourDateValidationMessage(ils.viewModel.ProspectForm.StepManager);
        });
        const shareLinks = document.querySelectorAll(".share-links a[target='_blank']");
        shareLinks.forEach(link => {
            link.addEventListener("click", (event) => {
                event.preventDefault();
                window.open(link.getAttribute("href"), link.getAttribute("title"), 'width=640,height=300');
            });
        });
        const photoModal = document.querySelector("#photo-modal");
        if (photoModal) {
            photoModal.addEventListener("keydown", (e) => {
                var _a, _b;
                switch (e.key) {
                    case "ArrowLeft":
                        (_a = document.querySelector(".modal-navigation .prev")) === null || _a === void 0 ? void 0 : _a.click();
                        break;
                    case "ArrowRight":
                        (_b = document.querySelector(".modal-navigation .next")) === null || _b === void 0 ? void 0 : _b.click();
                        break;
                    default:
                        return;
                }
                e.preventDefault();
            });
        }
        if (!$("#neighborhood").hasClass("all-blocks")) {
            $("#neighborhood .on-the-left").append($("#neighborhood .summary"));
        }
        // Write a vanilla JS query for all elements containing the class 'other-communities' and loop through them to add the click event
        const otherCommunities = document.querySelectorAll(".other-communities .community");
        otherCommunities.forEach(community => {
            community.addEventListener("click", (e) => {
                var _a;
                let element = e.target;
                while (element && !element.getAttribute('href')) {
                    element = element.parentNode;
                }
                if (element && !hasRoles) {
                    ils.trackCDPClickEvent({
                        communityId: ils.communityId,
                        communityName: ils.communityName,
                        communityUrl: ils.communityUrl,
                        clickTypeId: ClickType.ScheduleTourNearbyCommunities,
                        clickType: getClickTypeNameFromId(ClickType.ScheduleTourNearbyCommunities),
                        relatedData: (_a = element.querySelector(".name")) === null || _a === void 0 ? void 0 : _a.textContent
                    });
                }
                const iframeModal = parent.document.querySelector("#iframe-modal");
                if (iframeModal) {
                    const iframe = iframeModal.querySelector("iframe");
                    if (iframe) {
                        iframe.setAttribute("src", element.getAttribute("href") || "");
                        e.preventDefault();
                    }
                }
            });
        });
        $(".reset-floorplans").on('click', function () {
            ils.viewModel.BedroomMin(null);
            ils.viewModel.BedroomMax(null);
            ils.viewModel.PriceMin(null);
            ils.viewModel.PriceMax(null);
            var sliderElement = $("#uxPriceRangeSlider");
            if (sliderElement.length > 0) {
                sliderElement.slider("values", [sliderElement.slider("option", "min"), sliderElement.slider("option", "max")]);
                // We do not want to adjust handle margins if there is only one possible value
                var handle = sliderElement.find(".ui-slider-handle");
                const min = handle.attr("aria-valuemin");
                const max = handle.attr("aria-valuemax");
                if (min !== max) {
                    handle.removeClass("on-top");
                }
                sliderElement.find(".handle-text:first").html("$" + sliderElement.slider("option", "min"));
                sliderElement.find(".handle-text:last").html("$" + sliderElement.slider("option", "max"));
            }
            priceSliderUpdateFilter(sliderElement);
            sliderElement = $("#uxBedroomRangeSlider");
            if (sliderElement.length > 0) {
                sliderElement.slider("values", [sliderElement.slider("option", "min"), sliderElement.slider("option", "max")]);
                // We do not want to adjust handle margins if there is only one possible value
                var handle = sliderElement.find(".ui-slider-handle");
                const min = handle.attr("aria-valuemin");
                const max = handle.attr("aria-valuemax");
                if (min !== max) {
                    handle.removeClass("on-top");
                }
                sliderElement.find(".handle-text:first").html(FormatBedroomText(sliderElement.slider("option", "min")));
                sliderElement.find(".handle-text:last").html(FormatBedroomText(sliderElement.slider("option", "max")));
            }
            bedroomSliderUpdateFilter(sliderElement);
            FixHeightsAfterImagesLoaded($("#floorplans"));
            return false;
        });
        $(".read-more").on('click', function () {
            if (!readMoreClicked) {
                ils.trackCDPClickEvent({
                    communityId: ils.communityId,
                    communityName: ils.communityName,
                    communityUrl: ils.communityUrl,
                    clickTypeId: ClickType.Details,
                    clickType: "Read More"
                });
                //ga('send', 'event', 'CDPMoreInformation', 'click', globalThis.currentURL);
            }
            readMoreClicked = true;
        });
        $(".favorite").on('click', function () {
            if (!loggedIn) {
                parent.$("#uxExtraAction").val(`Favorited:${globalThis.showcaseItemID}`);
                return;
            }
            $(this).toggleClass("on");
            if ($(this).hasClass("on"))
                $(".trash").removeClass("on");
            $.ajax({
                type: 'POST',
                url: globalThis.baseUrl + "TftServices/MyFolder/MyFolderWebMethods.asmx/ToggleFavorite",
                data: `{ showcaseItemID: "${globalThis.showcaseItemID}", favorited: "${$(this).hasClass("on")}"}`,
                contentType: 'application/json; charset=utf-8',
                dataType: 'json'
            });
        });
        $(".trash").on('click', function () {
            if (!loggedIn) {
                parent.$("#uxExtraAction").val(`Trashed:${globalThis.showcaseItemID}`);
                return;
            }
            $(this).toggleClass("on");
            if ($(this).hasClass("on"))
                $(".favorite").removeClass("on");
            $.ajax({
                type: 'POST',
                url: globalThis.baseUrl + "TftServices/MyFolder/MyFolderWebMethods.asmx/ToggleTrash",
                data: `{ showcaseItemID: "${globalThis.showcaseItemID}", trashed: "${$(this).hasClass("on")}"}`,
                contentType: 'application/json; charset=utf-8',
                dataType: 'json'
            });
        });
        window.addEventListener('scroll', function (e) {
            if (isAutoScrolling === true) {
                return;
            }
            setTabFromScrollPosition();
        });
        //maps.initializeNeighborhoodMap();
        //maps.initializeMap();
        if (!ils.floorPlanLoaded) {
            var floorPlanTimeout = setTimeout(function () {
                BindPriceSlider();
                BindBedroomSlider();
                ils.floorPlanLoaded = true;
                FixHeightsAfterImagesLoaded($("#floorplans"));
                clearTimeout(floorPlanTimeout);
            }, 1000);
        }
        setTabFromScrollPosition();
        var positionTimeout = setTimeout(function () {
            // Now check to see if we have a URL fragment pointing to a different 
            var url = document.location.toString();
            var scheduleTour = getQueryVariable("scheduleTour");
            if (url.match('#') && !scheduleTour) {
                $('.cdp-menu a[href="#' + url.split('#')[1] + '"]').click();
            }
            else if (scheduleTour) {
                var scheduleTourTimeout = setTimeout(function () {
                    $(".schedule-tour").click();
                    clearTimeout(scheduleTourTimeout);
                }, 1000);
            }
            clearTimeout(positionTimeout);
        }, 500);
        ils.viewModel.GetInfoButtonsVisible(true);
    });
})(ils || (ils = {}));
